/* ══════════════════════════════════════════════════════════════════════
   Skön Cosmetics — skon-quiz.js
   asset: assets/skon-quiz.js
   Aggiornato: 10 giugno 2026 — 06:15
   Versione: 3.1.0

   Modifiche v3.1.0 — quiz_hero_product nel payload Magnews (funzionale):
   - ADD (funzionale): nuovo campo `quiz_hero_product` nel userProfile payload
     a Magnews. Contiene l'ID prodotto hero della routine (es. 'forever_young_cream',
     'bakuplex_serum'), letto da window.SkonRoutine.get(code).heroProduct.id
     (factory-resolved, rispetta heroOverride v1.6.0).
   - MOTIVAZIONE: E2 v0.6 ha 6 varianti hero (A1-6/A7-9/B1-2/B3-4/C/D), branch
     su QUIZ_HERO_PRODUCT nuovo campo Magnews. Senza questo campo, il branch
     dovrebbe usare QUIZ_CORE_2 che NON discrimina correttamente (B1-2 e B3-4
     hanno entrambi siero=arctic_waterfalls, A1-6 hanno sieri diversi).
   - FALLBACK: try/catch + fallback stringa vuota se SkonRoutine non disponibile
     (race condition improbabile dato l'ordine defer dei JS, ma safety net).
   - DEPLOY ATOMICO con skon-quiz-logic-data.js v1.6.0 (espone heroProduct con
     override) e Worker v2.10.0 (whitelist QUIZ_HERO_PRODUCT).
   - INVARIATO: tutto il resto. Modifica solo additiva nel payload + 1 variabile
     temp prima di userProfile. Pixel event QuizCompleted v3.0.1 invariato.

   Modifiche v3.0.1 — Meta Pixel custom event QuizCompleted (funzionale):
   - ADD (funzionale): nuova funzione trackQuizCompletedEvent(payload) che
     spara fbq('trackCustom', 'QuizCompleted', {...}) con tutte le property
     denormalizzate del quiz: routine_code, profile_letter, age_range,
     age_cluster, skin_self, desire, spf_habit, spf_interest, is_returning,
     discount_group, core_1..4, tip_1..3, hero_product (calcolato via
     SkonRoutine), currency='EUR', value=42.
   - ADD (funzionale): call site in submitEmail subito dopo trackQuizLead
     (linea ex-1750). Pattern fire-and-forget, errori catturati in try/catch.
   - MOTIVAZIONE: abilitare Custom Audience Meta hyper-segmentate basate su
     ANY combinazione di property (es. profile_letter=A AND core_1=
     forever_young_cream AND age_cluster=matura) senza nuove modifiche al
     pixel. Giuseppe costruisce le audience da Meta Ads Manager combinando
     le property a piacere — il quiz manda l'evento, Meta fa il filtering.
   - INVARIATO: trackQuizLead (event 'Lead' standard) bit-per-bit identica;
     fbq('init', ..., {em: hashedEmail}) eseguito da trackQuizLead PRIMA
     di QuizCompleted → quest'ultimo eredita l'advanced matching email
     senza re-hash.
   - INVARIATO: tutto il resto (routing, payload Magnews, side-cart, UI).
   - Deploy STANDALONE: nessuna dipendenza atomica con altri file.
   - SkonRoutine: usato per ageCluster (getAgeCluster) e heroProduct
     (get(code).heroProduct.id) — degradazione silenziosa a stringa vuota
     se SkonRoutine non disponibile (race CDN improbabile dato l'ordine
     defer in quiz-main.liquid v2.0.8).

   Modifiche v3.0.0 — Consumer puro SkonRoutine, no più logica email duplicata (TD-1):
   - REMOVE (architetturale): rimosse le funzioni interne dead code
       • buildEmailProductsHtml(coreIds, discountCode, profileLetter, isRC, spwParams)
       • buildEmailRoutineHtml(coreIds, profileLetter, discountCode, isRC, spwParams)
     (~165 righe totali, incluso docblock buildEmailRoutineHtml). Duplicavano
     logica step + lettura CATALOG locale → fonte di disallineamento col
     refactor SkonRoutine. Le 3 call site rimaste (E1, E4, products E1)
     ora delegano TUTTE a window.SKON_EMAIL.* con la firma nuova
     (routineCode, customer).
   - REFACTOR (funzionale): payload Magnews submitEmail:
       • quiz_email_products_html: ora chiama
         SKON_EMAIL.buildProductsHtml(routineCode, customer) — prima era la
         buildEmailProductsHtml interna.
       • quiz_email_e1_html: chiamata a SKON_EMAIL.buildE1 aggiornata alla
         nuova firma (routineCode, customer). Prima usava la firma legacy
         object-based ({firstName, profileLetter, desire, age, interestSpf,
         coreIds, ...}) gestita dallo shim retrocompat di email-content.
         Lo shim viene rimosso atomicamente in email-content v2.10.0 (TD-8).
       • quiz_email_routine_html: INVARIATO (già usava la nuova firma in
         v2.6.0).
     Pattern fallback-safe `(window.SKON_EMAIL && typeof ... === 'function')`
     preservato in tutte e 3 le call site.
   - Output runtime: bit-per-bit identico al pre-refactor (192/192 confronti
     validati in sessione 29 mag — 28 routine × scenari NC/RC × 3 funzioni).
     Smoke test E2E post-deploy raccomandato comunque.
   - Deploy ATOMICO con skon-quiz-email-content.js v2.10.0 (rimozione shim).

   Modifiche v2.7.0 — Cleanup payload submitEmail (TD-15):
   - REMOVE (funzionale): rimossi 2 campi morti dal payload userProfile
     mandato al Worker Magnews /subscribe:
       • quiz_is_repeat
       • is_returning_customer
     Entrambi NON sono nella whitelist statica del Worker buildMergePayload
     (35 campi) — il Worker li scarta in silenzio già da v2.4.0+. Il branch
     RC/NC del Journey idjourney=6 usa body.isExistingCustomer (top-level
     dedicato), non questi campi. La rimozione non cambia il comportamento
     runtime — Magnews vede lo stesso payload utile di prima.
   - Motivo: rumore fuorviante che aveva già fatto inciampare audit
     precedenti (B2 audit 26 mag, NC-R1 indagine 28 mag). Pulizia operativa.
   - NON toccato: quiz_is_repeat_completion (campo diverso, suffisso
     _completion) e tutti gli altri campi del lifecycle quiz (righe 1842+).
   - Deploy STANDALONE (NON atomico): rimozione 2 righe, zero dipendenze.

   Modifiche v2.6.0 — E4 delegato a SkonRoutine (single source of truth):
   - FIX (funzionale): il campo Magnews quiz_email_routine_html non è più
     generato dalla funzione interna buildEmailRoutineHtml() (che duplicava la
     logica step leggendo il CATALOG locale di questo file), ma delegato a
     window.SKON_EMAIL.buildRoutineHtml(routineCode, …) → narrativa mattino/sera
     verbatim Clio da window.SkonRoutine (≥ v1.4.0). Stesso pattern fallback-safe
     già usato per quiz_email_e1_html.
   - buildEmailRoutineHtml() interna NON rimossa (resta dead code): rimozione
     rimandata al refactor v3.0.0 (TD-1) per mantenere il diff minimo (1 hunk).
   - Deploy ATOMICO con skon-quiz-logic-data.js v1.4.0 + skon-quiz-email-content.js
     v2.2.0.

   Modifiche v2.5.0 — FIX nome utente nelle email + audit commenti:
   - FIX (funzionale): nel payload Magnews il nome utente per le email E1/E4
     era letto da S.firstName, proprietà MAI assegnata nello stato S → il
     campo risultava sempre stringa vuota. Conseguenza: parametro spw_name nei
     link e firstName passato a SKON_EMAIL.buildE1() sempre vuoti, quindi email
     E1 (primo contatto post-quiz) e link E1/E4 NON personalizzati col nome.
     Corretto in S.userName (già il primo nome, valorizzato in checkForm) nei
     3 punti: buildEmailProductsHtml (E1), buildEmailRoutineHtml (E4),
     SKON_EMAIL.buildE1.
   - DOC: corretto commento fuorviante in initResumeFlow (la navigazione a Q1
     avviene via introBtn.onclick in _injectResumeBanner, non automaticamente).
   - DOC: corretto commento di buildEmailRoutineHtml che citava prodotti
     hardcoded (Vitamin Blast/Over The Moon) non presenti nel codice, che
     lavora su coreIds[] generici.
   - Nessun'altra modifica di logica. Audit commenti riga-per-riga del file
     completato (report di sessione 25 mag): restanti reperti = refactor futuri
     (ANSWER_LABELS e sticky bar verso SKON_TEXTS; rivalutazione tracking GA4).

   Modifiche v2.4.5 — Refresh drawer del tema via CartUpdateEvent:
   - _notifyCartUpdate() ora dispatcha l'evento standard 'cart:update'
     (ThemeEvents.cartUpdate) su document con bubbles. Il cart-items-component
     del tema lo ascolta e fa autonomamente sectionRenderer.renderSection()
     della propria sezione (cart-drawer-host, v1.0). Questo mantiene il
     drawer sincronizzato col cart reale dopo ogni add-to-cart fatto dal
     quiz via fetch raw a /cart/add.js.
   - Richiede sections/cart-drawer-host.liquid v1.0 (sezione standalone)
     e layout/quiz.liquid v1.3 che la include via {% section %}.
   - Senza questo dispatch, il drawer renderizzato lato Liquid al page load
     restava "congelato" con i prodotti del cart al momento della richiesta
     della pagina, ignorando le modifiche fatte da addAllToCart.

   Modifiche v2.4.4 — Hydration cart-drawer via layout/quiz.liquid v1.1:
   - Nessun cambio di logica. _bindHeaderCart() (v2.4.3) ora funziona
     correttamente perché layout/quiz.liquid v1.1 include
     {%- render 'scripts' -%} che attiva l'hydration del custom element
     cart-drawer-component del tema. Prima della v1.1 del layout,
     cart-drawer-component era HTML inerte e drawer.open() era undefined.
   - Bump per coerenza stack v2.0.6/v1.1.

   Modifiche v2.4.3 — Apertura side-cart del tema via JS:
   - Nuova funzione _bindHeaderCart(): al DOMContentLoaded intercetta il
     click su #headerCart e chiama cartDrawerElement.open() del tema.
     Fallback: se cart-drawer-component non è nel DOM, redirect a /cart.
   - Richiede quiz-main.liquid v2.0.5+ con {% render 'cart-drawer' %}.
   - Approccio programmatico (no declarative on:click="/open"): più robusto,
     non dipende dall'hydration del tema. Funziona anche se l'inizializzazione
     dei custom elements del tema arriva DOPO il bootstrap del quiz.

   Modifiche v2.4.2 — SANITIZZAZIONE COMPLETA UpCart:
   Rimossa ogni traccia di UpCart dal codebase, in tutte le sue forme.
   UpCart è stata abbandonata come gestore del carrello e non sarà più
   usata. Lo stack del cart è ora esclusivamente l'Online Store 2.0
   standard del tema (Theme.routes.cart_update_url + cart-drawer-component).

   RIMOSSI:
   - function patchCheckoutLink(code) — patchava link checkout dentro
     UpCart shadowRoot. Inutile per il tema standard.
   - function startDiscountObserver() — MutationObserver su #upCart per
     riapplicare sconto. Inutile: il tema standard gestisce
     DiscountUpdateEvent autonomamente.
   - Chiamata startDiscountObserver() all'init.
   - Esposizioni window.patchCheckoutLink, window.startDiscountObserver.
   - In _notifyCartUpdate: chiamate window.upcartRefreshCart e
     window.upcartOpenCart. Sostituite con dispatch di CustomEvent
     'cart:refresh' su document, compatibile con il tema standard.
   - Chiamata patchCheckoutLink(code) dentro applyDiscount() (rimossa).
   - Liquid: rimosso on:click="/open" da #headerCart, sostituito con
     <a href="/cart"> standard (sulla pagina quiz il drawer non è
     renderizzato, quindi l'header-cart porta a /cart standard).

   Bug originario (v2.4.1) era TypeError dentro window.upcartOpenCart()
   chiamata da _notifyCartUpdate dopo addAllToCart. Sanitizzando le
   dipendenze UpCart, il bug sparisce per costruzione.

   Modifiche v2.4.1 — HOTFIX UpCart crash blocca addAllToCart:
   - _notifyCartUpdate() ora avvolge in try/catch le chiamate a UpCart
     (window.upcartRefreshCart e window.upcartOpenCart). UpCart è stata
     abbandonata come gestore primario del carrello, ma è ancora installata
     come app Shopify e registra le proprie funzioni globali. Internamente
     però queste funzioni crashano con un TypeError perché operano su uno
     shadowRoot non più esistente.
   - PRIMA del fix: in addAllToCart, dopo le 4 fetch /cart/add.js + apply
     discount, _notifyCartUpdate() crashava, interrompendo l'esecuzione
     prima del toast + redirect. Bottone "Aggiungo…" stuck, carrello
     pieno ma nessun feedback all'utente.
   - DOPO il fix: gli errori UpCart vengono catturati silenziosamente,
     il flow continua fino al toast + redirect /checkout.
   - Bug intercettato via test E2E in browser reale (Chrome MCP) il
     18/05/2026. Aggiungere ai test pre-deploy: simulazione click bottone
     end-to-end intercettando eccezioni runtime (non solo syntax check).

   Modifiche v2.4.0 — Checkout diretto con toast 2s:
   - addAllToCart('core'): dopo successo dei 4 add-to-cart + applyDiscount,
     mostra un toast bottom-center "Routine aggiunta — vai al checkout"
     per 2 secondi, poi redirect a /discount/CODE?redirect=/checkout
     (pattern Shopify ufficiale che riapplica il codice anche se la sessione
     è invalida o scaduta).
   - Nuova funzione _showCheckoutRedirectToast(msg, delayMs, redirectUrl):
     overlay fixed bottom, fade-in/out 300ms, timer setTimeout per redirect.
   - Edge case: se errorCount > 0, NESSUN redirect. Bottone mostra il toast
     di errore parziale e l'utente resta sulla pagina.
   - Reset btn.innerHTML prima di 'Aggiungo…' per evitare residui dal
     CTA precedente (CTA + sub-line).
   - REQUISITI: skon-quiz-texts.js v2.6+ (con toastRoutineAdded,
     toastRoutineError, ctaAddingShort).

   Modifiche v2.3.7 — HOTFIX bug grave "Aggiungi tutta la routine":
   - L'onclick del bottone "Aggiungi tutta la routine" passava 3 argomenti
     a addAllToCart, ma la funzione ne accetta 1. Risultato: section diventava
     l'elemento DOM (truthy ma != 'core'), quindi il branch ELSE leggeva
     resultData.tips invece di resultData.core. Il bottone aggiungeva i 3 TIPS
     al carrello invece dei 4 CORE consigliati. Bug introdotto in v2.3.4.
   - Fix: onclick="addAllToCart('core')" (formato corretto, 1 argomento).
   - Bottone ora ha id="btnAddRoutine" così addAllToCart lo trova per il
     feedback testuale ("Aggiungo…" → "Aggiunto al carrello!").

   Modifiche v2.3.6 — HOTFIX regressione _toggleNameField:
   - Esposta _toggleNameField su window. Era dichiarata ma non esposta,
     quindi il link "Modifica il nome" (onclick HTML inline nel Liquid)
     non rispondeva al click in modalità RC.
   - Bug preesistente (presente anche nel codice pre-v2.3). Intercettato
     ora con un nuovo audit cross-file onclick→window aggiunto come check
     standard pre-deploy.

   Modifiche v2.3.5:
   - _renderAddAllRoutineCta(): branch RC ora usa sub-line neutro
     'Lo sconto si applica automaticamente al carrello' (placeholder
     per v2.6+). Evita il messaggio fuorviante "primo X €, secondo Y €"
     che _buildCartBtnHtml produrrebbe per RC su 4 prodotti.
   - Branch NC invariato (sub-line '<s>orig</s> → discounted (-PCT%)').
   - REQUISITO: skon-quiz-texts.js v2.5+ (con ctaAddRoutineSubRC).

   Modifiche v2.3.4 — FIX UX schermata email RC + schermata risultato:
   - FIX 1: _showNameAutofillBanner(firstName) ora produce title dinamico
     'CHE BELLO RIVEDERTI, [NOME]!' invece di 'CHE BELLO RIVEDERTI' generico.
     Prima il nome non era visibile da nessuna parte (input nascosto in RC),
     rendendo la domanda "è corretto il tuo nome?" senza senso.
   - FIX 2: openVariantSheet() ora sovrascrive a runtime la label
     'Seleziona la variante' e il testo del bottone secondario 'Vedi la scheda
     completa' (rinominato in 'Vedi prodotto' per allineamento con CTA card).
     Testi letti da SKON_TEXTS.result via _t().
   - FIX 3: nuova funzione _renderAddAllRoutineCta(coreIds) chiamata da
     renderResult dopo le 4 card core. Genera un bottone CTA stilisticamente
     identico al varConfirmBtn del variant sheet: "Aggiungi tutta la routine
     al carrello" + sub-line con prezzo totale (con sconto applicato).
     Sub-line dinamica: per NC mostra '<s>orig</s> → discounted (-XX%)';
     per RC mostra 'primo X €, secondo Y €' (sconto 2° prodotto).

   REQUISITI:
   - skon-quiz-texts.js v2.4+

   Modifiche v2.3.3:
   - Refactor architetturale schermata risultato: tutti i 18 testi UI della
     schermata risultato (renderResult, _buildProductCard, addRestartButton,
     handleInterest/ATC, openDetailSheet, openVariantSheet, AK lightbox) ora
     letti da SKON_TEXTS.result via nuovo helper _t(key, vars).
   - _t(key, vars) supporta interpolazione di placeholder {{var}} per testi
     con dati dinamici (es. 'Aggiungi {{code}} al carrello', 'Aggiunto ({{ok}}/{{total}})').
   - Prima della v2.3.3 i testi del result erano hardcoded e SKON_TEXTS.result
     era codice morto — stesso anti-pattern di SKON_TEXTS.questions risolto in v2.3.2.
   - Nessuna divergenza di copy con la pre-patch (header "La tua routine
     personalizzata" mantenuto, tutti gli altri testi invariati).

   REQUISITI:
   - skon-quiz-texts.js v2.3+ (SKON_TEXTS.result con 18 chiavi)

   Modifiche v2.3.2:
   - Aggiunta funzione renderQuestionScreens() che popola a runtime gli shell
     <div class="screen" id="s-N" data-question="X"></div> di quiz-main.liquid
     v2.0+ leggendo SKON_TEXTS.questions.{age,skin,desire,spf} v2.2+.
   - Prima della v2.3.2 i testi degli step del quiz erano hardcoded in
     quiz-main.liquid e SKON_TEXTS.questions era codice morto. Dalla v2.3.2
     SKON_TEXTS è fonte autoritativa unica: il marketing può modificare
     testi/emoji/pill solo editando skon-quiz-texts.js.
   - renderQuestionScreens() viene chiamata all'init PRIMA di initResumeFlow()
     così le screen esistono quando il resume cerca di ripristinare lo stato.

   REQUISITI:
   - skon-quiz-texts.js v2.2+
   - quiz-main.liquid v2.0+ (shell vuoti con data-question)

   Modifiche v2.3.1 (rispetto a 2.3.0):
   - Label fasce d'età corrette per evitare sovrapposizioni ai bordi:
     · '25–35 anni' → 'Da 26 a 35 anni'
     · '35–45 anni' → 'Da 36 a 45 anni'
     · '45–55 anni' → 'Da 46 a 55 anni'
     · 'Meno di 25 anni' e '55+ anni' invariati
     Slug DB (chiavi 25-35, 35-45, 45-55) INVARIATI per non rompere
     compatibilità con record Magnews esistenti, lookup routine, audience
     dinamiche e dati GA4 storici.
     Narrativa email mantiene "Tra i 25 e i 35 anni" via QUIZ_AGE_INTRO
     in skon-quiz-email-content.js (decisione: decennio narrativo tondo
     anche se label UI sono 26-35).

   Modifiche rispetto a 2.2.0:
   - Integrazione con asset esterno skon-quiz-email-content.js:
     · Espone window.SKON_EMAIL.buildE1(profile) per generare maincontent E1
     · Tutti i contenuti narrativi E1 vivono nell'asset esterno, non più nel
       template Magnews (Magnews diventa shell con 1 placeholder)
   - Aggiunto campo quiz_email_e1_html al payload Magnews subscribe
     · Generato chiamando window.SKON_EMAIL.buildE1(profile) con tutti i dati
       necessari (firstName, profileLetter, desire, age, interestSpf, coreIds,
       discountCode, discountPct, isRC)
     · Fallback safe: se SKON_EMAIL non è caricato, campo resta stringa vuota
   - DIPENDENZA: skon-quiz-email-content.js deve essere caricato PRIMA di
     skon-quiz.js nel layout Shopify (theme.liquid). Ordine corretto:
       1. skon-quiz-priority.js (defer)
       2. skon-quiz-texts.js    (defer)
       3. skon-quiz-email-content.js (defer)  ← NUOVO
       4. skon-quiz.js          (defer)

   Modifiche rispetto a 2.1.2:
   - Aggiunta funzione buildEmailRoutineHtml() per generare il campo
     quiz_email_routine_html usato dal template E4 (Come usare la tua routine)
   - Pattern speculare a buildEmailProductsHtml (E1): 6 card prodotto in
     flusso verticale, una per ciascuno step (3 mattino + 3 sera)
   - Mapping eccezioni AK SPF:
     · Profilo C → AK Matt (anziché Glow)
     · Tutti gli altri profili → AK Glow
   - Numero card per profilo:
     · Profili A/B/C → 6 card (3 mattino + 3 sera: detergente, siero, crema)
     · Profilo D → 5 card (3 mattino + 2 sera): la routine D ha una sola crema
       serale (Over The Moon), non un siero+crema separati
   - Aggiunto campo quiz_email_routine_html al payload Magnews subscribe

   Modifiche di 2.1.2 rispetto a 2.0.0:
   - Resume parziale: banner "Bentornata!" sopra ogni step già risposto
   - _buildAnswerPills: label domanda prima di ogni risposta
   - Banner CRM: "CHE BELLO RIVEDERTI" uppercase + reset al cambio email
   - Prefetch accordion parallelo durante processing screen (3s)
   - _renderDetailSheet: tagline verde inline, gallery 1:1, accordion completi
   - openDetailInlineVariants: varianti compatte (>4), foto tonalità + lente
   - Lightbox tonalità AK (openTonalitaLightbox / closeTonalitaLightbox)
   - CATALOG: variantImgs per ak_glow e ak_matt (7 varianti × 2 prodotti)
   - Fix prezzi: dataset.price già in centesimi (rimosso * 100 errato)
   - Sticky bar: parte chiusa di default, NC verde / RC arancione,
     codice tratteggiato con pulsante copia, CTA catalogo
   - openVariantSheet: foto tonalità + layout compatto per AK
   - copyStickyCode esposta su window
══════════════════════════════════════════════════════════════════════ */

(function () {
'use strict';

/* ── Stato globale ───────────────────────────────────────────────────── */
var S = {
  step: 0,
  answers: { age: null, skin: null, desire: null, spf: null },
  userName:  '',
  userEmail: '',
  declaredInterests: [],
  routineCode: null,
  isReturningCustomer: false,
};

/* ── Cookie utilities ────────────────────────────────────────────────── */
function _setCookie(name, value, days) {
  var exp = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = name + '=' + encodeURIComponent(value)
    + '; expires=' + exp + '; path=/; SameSite=Lax';
}
function _getCookie(name) {
  var m = document.cookie.match('(?:^|;)\\s*' + name + '=([^;]*)');
  return m ? decodeURIComponent(m[1]) : null;
}

/* ══════════════════════════════════════════════════════════════════════
   QUIZ RESUME SYSTEM
   Storage: localStorage chiave 'skon_quiz_answers'
   Formato: { ts, answers: {age,skin,desire,spf}, lastStep: N }
   Scadenza: 30 giorni
══════════════════════════════════════════════════════════════════════ */
var RESUME_KEY  = 'skon_quiz_answers';
var RESUME_MS   = 30 * 864e5;

var ANSWER_LABELS = {
  age: {
    'lt25':   'Meno di 25 anni',
    '25-35':  'Da 26 a 35 anni',
    '35-45':  'Da 36 a 45 anni',
    '45-55':  'Da 46 a 55 anni',
    '55plus': '55+ anni'
  },
  skin: {
    normale:        'Pelle normale',
    disidratata:    'Pelle disidratata',
    secca_sensibile:'Pelle secca/sensibile',
    mista_grassa:   'Pelle mista/grassa',
    stanca_segnata: 'Pelle stanca/segnata'
  },
  desire: {
    levigata_rimpolpata: 'Levigata e rimpolpata',
    forte_morbida:       'Forte e idratata',
    libera_imperfezioni: 'Libera dalle imperfezioni',
    tonica_elastica:     'Tonica ed elastica',
    uniforme_luminosa:   'Uniforme e luminosa'
  },
  spf: {
    sempre:      'SPF: ogni giorno',
    a_volte:     'SPF: a volte',
    solo_al_mare:'SPF: solo al mare',
    raramente:   'SPF: raramente',
    mai:         'SPF: mai'
  }
};

function _saveProgress() {
  try {
    localStorage.setItem(RESUME_KEY, JSON.stringify({
      ts:       Date.now(),
      answers:  Object.assign({}, S.answers),
      lastStep: typeof S.step === 'number' ? S.step : 4
    }));
  } catch(e) {}
}
function _loadProgress() {
  try {
    var raw = localStorage.getItem(RESUME_KEY);
    if (!raw) return null;
    var data = JSON.parse(raw);
    if (!data || !data.ts || !data.answers) return null;
    if (Date.now() - data.ts > RESUME_MS) { localStorage.removeItem(RESUME_KEY); return null; }
    return data;
  } catch(e) { return null; }
}
function _clearProgress() {
  try { localStorage.removeItem(RESUME_KEY); } catch(e) {}
}

function _buildAnswerPills(answers) {
  var order = ['age','skin','desire','spf'];
  var questionLabels = {
    age:    'Età',
    skin:   'Allo specchio vedi',
    desire: 'Vorresti una pelle',
    spf:    'Usi la protezione solare',
  };
  var html = '';
  order.forEach(function(key) {
    var val = answers[key];
    if (!val) return;
    var answerLabel = (ANSWER_LABELS[key] && ANSWER_LABELS[key][val]) || val;
    var qLabel = questionLabels[key];
    html += '<div class="resume-pill-row">'
      + '<span class="resume-pill-q">' + qLabel + '</span>'
      + '<span class="resume-pill">' + answerLabel + '</span>'
      + '</div>';
  });
  return html;
}
function _countAnswers(answers) {
  return ['age','skin','desire','spf'].filter(function(k) { return !!answers[k]; }).length;
}


/* ══════════════════════════════════════════════════════════════════════
   Rendering schermate quiz da SKON_TEXTS (v2.3.2+)
   ──────────────────────────────────────────────────────────────────────
   Popola gli shell <div class="screen" id="s-N" data-question="X"></div>
   di quiz-main.liquid leggendo testi/opzioni da window.SKON_TEXTS.questions.
   Chiamata UNA volta all'init, prima di initResumeFlow().

   Q1 (age):    label semplice                  → <span class="opt-age-label">
   Q2 (skin):   primary + pill colorata         → <div class="opt-primary"> + <span class="opt-pill">
   Q3 (desire): emoji + titolo + descrizione    → <div class="opt-desire-title"> + <div class="opt-desire-desc">
   Q4 (spf):    emoji + titolo + descrizione    → <div class="opt-desire-title"> + <div class="opt-desire-desc">
══════════════════════════════════════════════════════════════════════ */

var _CHECK_SVG = '<div class="opt-check"><svg viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg></div>';

function _renderOptAge(opt) {
  return (
    '<div class="opt opt--age" onclick="pick(this,\'age\',\'' + opt.value + '\')">' +
      _CHECK_SVG +
      '<span class="opt-age-label">' + opt.label + '</span>' +
    '</div>'
  );
}

function _renderOptSkin(opt) {
  return (
    '<div class="opt" onclick="pick(this,\'skin\',\'' + opt.value + '\')">' +
      _CHECK_SVG +
      '<div class="opt-body">' +
        '<div class="opt-primary">' + opt.primary + '</div>' +
        '<span class="opt-pill ' + opt.pillClass + '">' + opt.secondary + '</span>' +
      '</div>' +
    '</div>'
  );
}

function _renderOptDesireOrSpf(opt, key) {
  var emoji = opt.emoji ? (opt.emoji + ' ') : '';
  return (
    '<div class="opt" onclick="pick(this,\'' + key + '\',\'' + opt.value + '\')">' +
      _CHECK_SVG +
      '<div class="opt-body">' +
        '<div class="opt-desire-title">' + emoji + opt.primary + '</div>' +
        '<div class="opt-desire-desc">' + opt.extended + '</div>' +
      '</div>' +
    '</div>'
  );
}

function _renderBackArrow() {
  return '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 5l-7 7 7 7"/></svg>';
}

function _renderForwardArrow() {
  return '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>';
}

function _renderBtnRow(stepN) {
  var prevStep = stepN - 1;
  var nextStep = (stepN === 4) ? "'email'" : (stepN + 1);
  return (
    '<div class="btn-row">' +
      '<button class="btn-back" onclick="go(' + prevStep + ')" aria-label="Indietro">' + _renderBackArrow() + '</button>' +
      '<button class="btn-primary off" id="b' + stepN + '" onclick="go(' + nextStep + ')">Continua ' + _renderForwardArrow() + '</button>' +
    '</div>'
  );
}

function _renderScreenInner(qKey, stepN, optsClass, renderOptFn) {
  var Q = window.SKON_TEXTS && window.SKON_TEXTS.questions && window.SKON_TEXTS.questions[qKey];
  if (!Q) return '';

  var optsHtml = Q.options.map(function(opt) { return renderOptFn(opt, qKey); }).join('');
  var subHtml  = Q.sub ? '<p class="q-sub">' + Q.sub + '</p>' : '';

  return (
    '<p class="q-category">' + Q.label + '</p>' +
    '<h2 class="q-text">' + Q.title + '</h2>' +
    subHtml +
    '<div class="' + optsClass + '">' + optsHtml + '</div>' +
    _renderBtnRow(stepN)
  );
}

function renderQuestionScreens() {
  if (!window.SKON_TEXTS || !window.SKON_TEXTS.questions) {
    console.warn('[skon-quiz] SKON_TEXTS.questions non disponibile, rendering quiz saltato');
    return;
  }
  var screens = [
    { id: 's-1', key: 'age',    step: 1, optsClass: 'opts',          render: _renderOptAge },
    { id: 's-2', key: 'skin',   step: 2, optsClass: 'opts opts--verbose', render: _renderOptSkin },
    { id: 's-3', key: 'desire', step: 3, optsClass: 'opts opts--verbose', render: _renderOptDesireOrSpf },
    { id: 's-4', key: 'spf',    step: 4, optsClass: 'opts opts--verbose', render: _renderOptDesireOrSpf },
  ];
  screens.forEach(function(sc) {
    var el = document.getElementById(sc.id);
    if (!el) {
      console.warn('[skon-quiz] Shell #' + sc.id + ' non trovato in DOM');
      return;
    }
    // Solo se è uno shell vuoto (compat con vecchio Liquid che ha contenuti hardcoded)
    if (el.children.length > 0) return;
    el.innerHTML = _renderScreenInner(sc.key, sc.step, sc.optsClass, sc.render);
  });
}

/* ══════════════════════════════════════════════════════════════════════
   Helper _t() — lettura testi UI da SKON_TEXTS.result (v2.3.3+)
   ──────────────────────────────────────────────────────────────────────
   Legge SKON_TEXTS.result[key] con interpolazione opzionale di placeholder
   {{var}}. Fallback safe: se la chiave manca, ritorna stringa vuota e
   logga un warning una sola volta (per evitare spam in console).

   Uso:
     _t('btnInterested')                            → 'Mi interessa'
     _t('btnAddVariantToCart', { code: 'Light 02' }) → 'Aggiungi Light 02 al carrello'
     _t('cartAddedPartial', { ok: 3, total: 4 })    → 'Aggiunto (3/4)'
══════════════════════════════════════════════════════════════════════ */

var _T_WARNED = {};

function _t(key, vars) {
  var R = window.SKON_TEXTS && window.SKON_TEXTS.result;
  var str = R ? R[key] : '';
  if (typeof str !== 'string') {
    if (!_T_WARNED[key]) {
      console.warn('[skon-quiz] _t: chiave SKON_TEXTS.result.' + key + ' mancante');
      _T_WARNED[key] = true;
    }
    return '';
  }
  if (vars) {
    Object.keys(vars).forEach(function(k) {
      str = str.split('{{' + k + '}}').join(vars[k]);
    });
  }
  return str;
}

function initResumeFlow() {
  if (_getCookie('skon_quiz_completed') === '1') return;
  var progress = _loadProgress();
  if (!progress || !progress.answers) return;
  var count = _countAnswers(progress.answers);
  if (count === 0) return;

  S.answers = Object.assign({}, progress.answers);

  if (count === 4) {
    // Tutte le risposte → mostra schermata resume dedicata
    _showFullResumeScreen(progress.answers);
  } else {
    // Risposte parziali → torna a Q1 con banner bentornato su ogni risposta già data
    _preSelectAnswers(progress.answers);
    _injectResumeBanner(count);
    // La navigazione a Q1 avviene al click sull'intro CTA: _injectResumeBanner
    // riassegna introBtn.onclick = go(1). L'utente resta sull'intro fino al click.
  }

  // Pre-compila email e nome se arriva da flusso RC micro-domanda
  try {
    var rcEmail = sessionStorage.getItem('skon_rc_email');
    var rcName  = sessionStorage.getItem('skon_rc_name');
    if (rcEmail) {
      var emailIn = document.getElementById('emailIn');
      var nameIn  = document.getElementById('nameIn');
      if (emailIn) emailIn.value = rcEmail;
      if (nameIn && rcName) nameIn.value = rcName;
      if (typeof window.checkForm === 'function') window.checkForm();
    }
  } catch(e) {}
}

function _showFullResumeScreen(answers) {
  var resumeEl = document.getElementById('s-resume');
  if (!resumeEl) return;
  var pillsHtml = _buildAnswerPills(answers);
  var pillsContainer = resumeEl.querySelector('#resumePills');
  if (pillsContainer) pillsContainer.innerHTML = pillsHtml;
  hide('s-intro');
  show('s-resume');
  S.step = 'resume';
  updateUI();
}

function _injectResumeBanner(count) {
  // Modifica la schermata intro per indicare che ci sono risposte salvate
  var introBtn = document.querySelector('#s-intro .btn-primary');
  if (introBtn) {
    introBtn.textContent = 'Continua dal quiz';
    introBtn.onclick = function() { go(1); };
  }
  var introEyebrow = document.querySelector('#s-intro .eyebrow');
  if (introEyebrow) {
    introEyebrow.textContent = 'Bentornata su Skön';
    introEyebrow.style.color = 'var(--orange)';
  }
  var introBody = document.querySelector('#s-intro .intro-body');
  if (introBody) {
    introBody.textContent = 'Avevi già iniziato il quiz. Abbiamo salvato le tue risposte — puoi continuare da dove avevi lasciato.';
  }

  // Inserisce banner "hai già risposto" su ogni step con risposta salvata
  var keyToStep = { age: 1, skin: 2, desire: 3, spf: 4 };
  Object.keys(S.answers).forEach(function(key) {
    if (!S.answers[key]) return;
    var stepNum   = keyToStep[key];
    var screenEl  = document.getElementById('s-' + stepNum);
    if (!screenEl) return;

    var existing = screenEl.querySelector('.resume-mini-banner');
    if (existing) return;

    var banner = document.createElement('div');
    banner.className = 'resume-mini-banner';
    banner.innerHTML =
      '<span class="resume-mini-icon">✓</span>'
      + '<span class="resume-mini-text">Avevi già risposto — puoi confermare o modificare la tua scelta.</span>';

    var qCat = screenEl.querySelector('.q-category');
    if (qCat) screenEl.insertBefore(banner, qCat);
    else screenEl.insertBefore(banner, screenEl.firstChild);
  });
}

function _preSelectAnswers(answers) {
  var keyToStep = { age:1, skin:2, desire:3, spf:4 };
  Object.keys(answers).forEach(function(key) {
    var val = answers[key];
    if (!val) return;
    var stepNum = keyToStep[key];
    var screenEl = document.getElementById('s-' + stepNum);
    if (!screenEl) return;
    var opts = screenEl.querySelectorAll('.opt');
    opts.forEach(function(opt) {
      var onclickAttr = opt.getAttribute('onclick') || '';
      if (onclickAttr.indexOf("'" + val + "'") !== -1 ||
          onclickAttr.indexOf('"' + val + '"') !== -1) {
        opt.classList.add('selected');
      }
    });
    var btn = document.getElementById('b' + stepNum);
    if (btn) btn.classList.remove('off');
  });
}

/* ── A/B test sconto NC ──────────────────────────────────────────────── */
function getDiscountGroup() {
  var existing = _getCookie('skon_quiz_group');
  if (existing === 'A' || existing === 'B') return existing;
  var cfg = window.SKON_AB_CONFIG;
  if (cfg && cfg.enabled === false) return 'A';
  var group = Math.random() < 0.5 ? 'A' : 'B';
  _setCookie('skon_quiz_group', group, 60);
  return group;
}
function getEffectiveNewDiscount() {
  var cfg   = window.SKON_AB_CONFIG || {};
  var group = getDiscountGroup();
  var gCfg  = (group === 'A' ? cfg.groupA : cfg.groupB) || {};
  return {
    group: group,
    code:  gCfg.code || (group === 'A' ? 'SK-QUIZ25' : 'SK-QUIZ30'),
    pct:   gCfg.pct  || (group === 'A' ? 0.25        : 0.30),
  };
}
function _getEffectiveRCDiscount() {
  var rc = window.SKON_RC_DISCOUNT || {};
  return {
    code: rc.code || 'SK-RITORNO',
    pct:  rc.pct  || 0.50,
  };
}

/* ── GA4 quiz funnel tracking ─────────────────────────────────────────── */
function trackGA4(eventName, params) {
  try {
    if (typeof window.gtag !== 'function') return;
    var base = {
      quiz_version: '2.0',
      ab_group:     _getCookie('skon_quiz_group') || 'unassigned',
      skin_type:    S.answers.skin   || '',
      age_range:    S.answers.age    || '',
      desire:       S.answers.desire || '',
    };
    window.gtag('event', eventName, Object.assign(base, params || {}));
  } catch(e) {}
}

function _installAbandonTracking() {
  function onAbandon() {
    if (S.step === 'result') return;
    trackGA4('quiz_abandon', {
      last_step: typeof S.step === 'number' ? S.step :
                 S.step === 'email' ? 5 :
                 S.step === 'proc'  ? 6 : 0,
      last_step_name: typeof S.step === 'number'
        ? 'domanda_' + S.step
        : (S.step || 'intro'),
    });
  }
  window.addEventListener('beforeunload', onAbandon);
  window._quizAbandonFn = onAbandon;
}
function _removeAbandonTracking() {
  if (window._quizAbandonFn) {
    window.removeEventListener('beforeunload', window._quizAbandonFn);
    window._quizAbandonFn = null;
  }
}

/* ── Helpers testi ────────────────────────────────────────────────────── */
function _dt(key, fallback) {
  return (window.SKON_TEXTS && window.SKON_TEXTS.discount && window.SKON_TEXTS.discount[key]) || fallback;
}

/* ── Costanti ──────────────────────────────────────────────────────────── */
var TOTAL = 4;
// CRM: Magnews (via Worker Cloudflare skon-quiz-check-magnews.admins-e7e.workers.dev)

var DISCOUNT_CONFIG = {
  get newCode()          { return getEffectiveNewDiscount().code; },
  get newPct()           { return getEffectiveNewDiscount().pct; },
  get returnCode()       { return _getEffectiveRCDiscount().code; },
  get returnPct()        { return _getEffectiveRCDiscount().pct; },
  get newCtaTitle()      { return _dt('newCtaTitle',      'Il tuo sconto di benvenuto'); },
  get newCtaSub()        { return _dt('newCtaSub',        'Controlla la tua email. Hai ricevuto il tuo protocollo e il codice sconto per iniziare.'); },
  get returnCtaTitle()   { return _dt('returnCtaTitle',   '\u00C8 BELLO RIVEDERTI'); },
  get returnCtaSub()     { return _dt('returnCtaSub',     'Con il codice {CODE} al checkout pagherai il secondo prodotto in carrello al {PCT}%. Puoi usarlo una sola volta. \u00C8 gi\u00e0 applicato al tuo carrello. Approfittane!'); },
  get newBadgeLabel()    { return _dt('newBadgeLabel',    '-{PCT}'); },
  get newBadgeNote()     { return _dt('newBadgeNote',     'Sconto applicato automaticamente alla cassa.'); },
  get returnBadgeNote()  { return _dt('returnBadgeNote',  'Lo sconto si applica automaticamente alla cassa.'); },
  get varPriceSecondLine(){ return _dt('varPriceSecondLine','Il secondo lo pagheresti'); },
};

/* ── Hash email per Meta Pixel ─────────────────────────────────────────── */
async function hashEmail(email) {
  var normalized = email.toLowerCase().trim();
  var encoder = new TextEncoder();
  var data = encoder.encode(normalized);
  var hashBuffer = await crypto.subtle.digest('SHA-256', data);
  return Array.from(new Uint8Array(hashBuffer)).map(function(b) { return b.toString(16).padStart(2,'0'); }).join('');
}
async function trackQuizLead(email, routineCode, profileLetter, coreAndTips) {
  if (typeof window.fbq !== 'function') return;
  var eventId = 'quiz_lead_' + Date.now();
  try {
    var hashedEmail = await hashEmail(email);
    window.fbq('init', '1747175969175346', { em: hashedEmail });
  } catch(e) { console.warn('[skon-quiz] Meta email hash failed:', e.message); }
  window.fbq('track', 'Lead', {
    content_name:     'Skin Test Skön',
    content_category: profileLetter,
    content_ids:      coreAndTips,
    num_items:        coreAndTips.length,
  }, { eventID: eventId });
}

/* ══════════════════════════════════════════════════════════════════════
   trackQuizCompletedEvent — Meta Pixel custom event 'QuizCompleted' (v3.0.1)
   ────────────────────────────────────────────────────────────────────────
   Sparato accanto al 'Lead' standard. Contiene property denormalizzate
   del quiz per consentire la creazione di Meta Custom Audience da Ads
   Manager senza richiedere modifiche al pixel: Giuseppe combina ogni
   dimensione (profile_letter × age_cluster × core_N × is_returning
   × discount_group ecc.) direttamente dall'UI Meta.

   PROPERTY ESPOSTE (tutte single-value, NO array — Meta gestisce meglio
   il filtering su property scalari):
     - routine_code     'A1'..'D9' (28 valori)
     - profile_letter   'A'|'B'|'C'|'D'
     - age_range        'lt25'|'25-35'|'35-45'|'45-55'|'55plus'
     - age_cluster      'giovane'|'matura'|'senior' (mapping SkonRoutine)
     - skin_self        5 valori (disidratata/mista_grassa/normale/...)
     - desire           5 valori
     - spf_habit        4-5 valori
     - spf_interest     boolean
     - is_returning     boolean
     - discount_group   'A'|'B' (solo NC, A/B test sconto)
     - core_1..core_4   ID catalogo prodotti core (es. 'forever_young_cream')
     - tip_1..tip_3     ID catalogo prodotti tip
     - hero_product     ID prodotto hero (siero>crema rule, da SkonRoutine)
     - currency         'EUR' (Meta value optimization)
     - value            42 (AOV stimato NC, per Lead ROAS optimization)

   IMPORTANTE: chiamare DOPO trackQuizLead. Quest'ultima esegue
   fbq('init', ..., {em: hashedEmail}) → l'advanced matching email
   viene applicato a tutti i fbq successivi nella stessa sessione,
   incluso questo QuizCompleted. Quindi NON rifacciamo init qui.

   DEGRADAZIONE: se SkonRoutine non disponibile (race CDN improbabile),
   ageCluster e heroProductId restano stringa vuota — l'evento parte
   comunque con le altre property valide. Se fbq non c'è (ad-blocker),
   return silenzioso.
══════════════════════════════════════════════════════════════════════ */
function trackQuizCompletedEvent(p) {
  if (typeof window.fbq !== 'function') return;
  try {
    var ageCluster    = '';
    var heroProductId = '';
    if (window.SkonRoutine && typeof window.SkonRoutine.getAgeCluster === 'function') {
      ageCluster = window.SkonRoutine.getAgeCluster(p.ageRange) || '';
    }
    if (window.SkonRoutine && typeof window.SkonRoutine.get === 'function') {
      var r = window.SkonRoutine.get(p.routineCode);
      heroProductId = (r && r.heroProduct && r.heroProduct.id) || '';
    }

    window.fbq('trackCustom', 'QuizCompleted', {
      // ── Routine identity (4 livelli di granularità) ─────────────────
      routine_code:    p.routineCode    || '',
      profile_letter:  p.profileLetter  || '',
      age_range:       p.ageRange       || '',
      age_cluster:     ageCluster,

      // ── Risposte raw del quiz (per audience ultra-segmentate) ───────
      skin_self:       p.skinSelf       || '',
      desire:          p.desire         || '',
      spf_habit:       p.spfHabit       || '',
      spf_interest:    !!p.spfInterest,

      // ── Customer lifecycle + A/B sconto ─────────────────────────────
      is_returning:    !!p.isRC,
      discount_group:  p.discountGroup  || '',

      // ── Prodotti routine (4 core + 3 tip + hero calcolato) ──────────
      core_1:          (p.coreIds && p.coreIds[0]) || '',
      core_2:          (p.coreIds && p.coreIds[1]) || '',
      core_3:          (p.coreIds && p.coreIds[2]) || '',
      core_4:          (p.coreIds && p.coreIds[3]) || '',
      tip_1:           (p.tipIds  && p.tipIds[0])  || '',
      tip_2:           (p.tipIds  && p.tipIds[1])  || '',
      tip_3:           (p.tipIds  && p.tipIds[2])  || '',
      hero_product:    heroProductId,

      // ── Meta value (Lead optimization) ──────────────────────────────
      currency:        'EUR',
      value:           42,
    });
  } catch(e) {
    console.warn('[skon-quiz] QuizCompleted pixel event failed:', e.message);
  }
}

/* ══════════════════════════════════════════════════════════════════════
   CATALOG — dati live aggiornati al 29 aprile 2026
   Fonte: fetch /collections/catalogo/products.json
══════════════════════════════════════════════════════════════════════ */
var CATALOG = [
  /* ── CLEAN ME UP ────────────────────────────────────────────────── */
  { id:'cmu_mousse', name:'Clean Me Up Cleansing Mousse', stepLabel:'Detersione',
    url:'https://skoncosmetics.com/products/mousse-detergente',
    handle:'mousse-detergente', variantId:55919114322295,
    shopVariants:[{id:55919114322295,title:'150 ml',price:1850},{id:55919114289527,title:'50 ml',price:1250}],
    imgs:['https://cdn.shopify.com/s/files/1/0785/8756/0209/files/01-CMU-mousse-gallery_copia.webp?v=1761569323','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/01-mini-CMU-mousse-gallery_copia.webp?v=1761569323','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/recap-CMU-mousse-gallery_copia.webp?v=1761654980','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/02-CMU-mousse-gallery_copia.webp?v=1761654980'],
    slug:'Mousse detergente', tagline:'Deterge, idrata, lenisce.' },

  { id:'cmu_gel', name:'Clean Me Up Cleansing Gel', stepLabel:'Detersione',
    url:'https://skoncosmetics.com/products/gel-detergente',
    handle:'gel-detergente', variantId:55919541584247,
    shopVariants:[{id:55919541584247,title:'150 ml',price:1850}],
    imgs:['https://cdn.shopify.com/s/files/1/0785/8756/0209/files/01-CMU-gel-gallerycopia.webp?v=1761569052','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/03-CMU-gel-gallerycopia.webp?v=1761597597','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/02-CMU-gel-gallerycopia.webp?v=1761597597','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/04-CMU-gel-gallerycopia.webp?v=1761569052'],
    slug:'Gel detergente', tagline:'Deterge, idrata, lenisce.' },

  { id:'cmu_balm', name:'Clean Me Up Cleansing Balm', stepLabel:'Detersione',
    url:'https://skoncosmetics.com/products/burro-detergente-struccante',
    handle:'burro-detergente-struccante', variantId:55914809622903,
    shopVariants:[{id:55914809622903,title:'100 gr',price:2400}],
    imgs:['https://cdn.shopify.com/s/files/1/0785/8756/0209/files/01-CMU-burro-gallery_copia.webp?v=1761569434','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/03-CMU-burro-gallery_copia.webp?v=1761597647','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/02-CMU-burro-gallery_copia.webp?v=1761597647','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/04-CMU-burro-gallery_copia.webp?v=1761569433'],
    slug:'Burro detergente struccante', tagline:'Elimina il make-up, nutre, rigenera.' },

  { id:'cmu_oil', name:'Clean Me Up Cleansing Oil', stepLabel:'Detersione',
    url:'https://skoncosmetics.com/products/olio-detergente-struccante',
    handle:'olio-detergente-struccante', variantId:55919697527159,
    shopVariants:[{id:55919697527159,title:'150 ml',price:2250},{id:55919697494391,title:'50 ml',price:1850}],
    imgs:['https://cdn.shopify.com/s/files/1/0785/8756/0209/files/01-CMU-olio-gallery_copia.webp?v=1761568782','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/01-mini-CMU-olio-gallery_copia.webp?v=1761568782','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/03-CMU-olio-gallery_copia.webp?v=1761597586','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/02-CMU-olio-gallery_copia.webp?v=1761597586'],
    slug:'Olio detergente struccante', tagline:'Elimina il make-up, nutre, rigenera.' },

  { id:'cmu_essence', name:'Clean Me Up Energy Essence', stepLabel:'Preparatore',
    url:'https://skoncosmetics.com/products/essenza-idratante-antiossidante',
    handle:'essenza-idratante-antiossidante', variantId:55917820707191,
    shopVariants:[{id:55917820707191,title:'150 ml',price:1850}],
    imgs:['https://cdn.shopify.com/s/files/1/0785/8756/0209/files/01-CMU-tonico-gallery_copia.webp?v=1761569521','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/03-CMU-tonico-gallerycopia.webp?v=1761597638','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/02-CMU-tonico-gallerycopia.webp?v=1761597638','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/04-CMU-tonico-gallerycopia.webp?v=1761569521'],
    slug:'Essenza idratante antiossidante', tagline:'Idrata, rinforza e prepara la pelle alla skincare.' },

  /* ── IMPERFECT ME ─────────────────────────────────────────────── */
  { id:'imperfect_gel_cleanser', name:'ImPerfect Me Cleansing Gel', stepLabel:'Detersione',
    url:'https://skoncosmetics.com/products/imperfect-me-gel-detergente-anti-imperfezioni',
    handle:'imperfect-me-gel-detergente-anti-imperfezioni', variantId:56863280005495,
    shopVariants:[{id:56863280005495,title:'150 ml',price:1850}],
    imgs:['https://cdn.shopify.com/s/files/1/0785/8756/0209/files/IM150-gallery-01.webp?v=1773933840','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/IM150-gallery-03.webp?v=1773933875','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/IM150-gallery-02.webp?v=1773933875','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/IM150-gallery-04.webp?v=1773933866'],
    slug:'Gel detergente anti-imperfezioni', tagline:'Purifica, idrata, lenisce.' },

  { id:'imperfect_exfol', name:'ImPerfect Me Exfoliating Lotion', stepLabel:'Esfoliazione',
    url:'https://skoncosmetics.com/products/imperfect-me-lozione-esfoliante',
    handle:'imperfect-me-lozione-esfoliante', variantId:56868216930679,
    shopVariants:[{id:56868216930679,title:'100 ml',price:1850}],
    imgs:['https://cdn.shopify.com/s/files/1/0785/8756/0209/files/IM100-gallery-01.webp?v=1773933574','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/IM100-gallery-03.webp?v=1773933616','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/IM100-gallery-02.webp?v=1773933616','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/IM100-gallery-04.webp?v=1773933599'],
    slug:'Lozione esfoliante', tagline:'Purifica, leviga la grana della pelle, illumina.' },

  { id:'imperfect_cream', name:'ImPerfect Me Blemish Control Cream', stepLabel:'Crema',
    url:'https://skoncosmetics.com/products/imperfect-me-crema-viso-anti-imperfezioni',
    handle:'imperfect-me-crema-viso-anti-imperfezioni', variantId:56879804776823,
    shopVariants:[{id:56879804776823,title:'40 ml',price:2400}],
    imgs:['https://cdn.shopify.com/s/files/1/0785/8756/0209/files/IM40-gallery01-box.webp?v=1774962343','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/IM40-gallery_03.webp?v=1775634120','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/IM40-gallery_02.webp?v=1775634120','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/IM40-gallery_04.webp?v=1774962415'],
    slug:'Crema anti-imperfezioni', tagline:'Purifica, idrata, lenisce.' },

  /* ── SIERI ────────────────────────────────────────────────────── */
  { id:'arctic_waterfalls', name:'Arctic Waterfalls', stepLabel:'Trattamento',
    url:'https://skoncosmetics.com/products/siero-viso-acido-ialuronico-puro',
    handle:'siero-viso-acido-ialuronico-puro', variantId:46950832406801,
    shopVariants:[{id:46950832406801,title:'30 ml',price:2800}],
    imgs:['https://cdn.shopify.com/s/files/1/0785/8756/0209/files/1-AW-main_copia.webp?v=1757316489','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/2-AW-mano_copia_1.webp?v=1757316490','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/3-AW-texture_copia_1.webp?v=1757316490','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/4-AW-ingrediente_copia_1.webp?v=1757316490'],
    slug:"Siero idratante all'Acido Ialuronico", tagline:'Idrata, lenisce e rimpolpa la pelle in profondit\u00e0.' },

  { id:'better_late', name:'Better Late Than Never', stepLabel:'Trattamento',
    url:'https://skoncosmetics.com/products/siero-bakuchiol-antirughe',
    handle:'siero-bakuchiol-antirughe', variantId:46950876283153,
    shopVariants:[{id:46950876283153,title:'30 ml',price:2800}],
    imgs:['https://cdn.shopify.com/s/files/1/0785/8756/0209/files/1-BLTN-main_copia.webp?v=1757316465','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/2-BLTN-mano_copia_1.webp?v=1757316465','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/3-BLTN-texture_copia_1.webp?v=1757316465','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/4-BLTN-ingrediente_copia_1.webp?v=1757316465'],
    slug:'Siero antiet\u00e0 levigante al Bakuchiol', tagline:'Stimola la produzione di Collagene ed Elastina per una pelle pi\u00f9 tonica e levigata.' },

  { id:'bakuplex_serum', name:'Bakuplex\u00ae Face Serum', stepLabel:'Trattamento',
    url:'https://skoncosmetics.com/products/bakuchiol-serum-viso-anti-age-bakuplex',
    handle:'bakuchiol-serum-viso-anti-age-bakuplex', variantId:48751103541521,
    shopVariants:[{id:48751103541521,title:'30 ml',price:3600}],
    imgs:['https://cdn.shopify.com/s/files/1/0785/8756/0209/files/BAKU-siero-gallery_1.webp?v=1775803001','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/BAKU-siero-gallery_2.webp?v=1775803001','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/BAKU-siero-gallery_3_testo.webp?v=1775803001','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/BAKU-siero-gallery_5.webp?v=1775803001'],
    slug:'Siero antiet\u00e0 globale Bakuplex\u00ae', tagline:'Stimola il rinnovamento cellulare, contrasta rughe e segni del tempo.' },

  { id:'siero_imperfezioni', name:'Pimple Potion', stepLabel:'Trattamento',
    url:'https://skoncosmetics.com/products/siero-anti-impefezioni',
    handle:'siero-anti-impefezioni', variantId:47290102251793,
    shopVariants:[{id:47290102251793,title:'30 ml',price:2800}],
    imgs:['https://cdn.shopify.com/s/files/1/0785/8756/0209/files/1-pimple-solo-main_copia_585d114f-82fe-4a41-9d9b-93626344ab74.webp?v=1759243062','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/2-pimple-mano_copia_84f75874-2b28-4578-87bf-39bb90386d70.webp?v=1759243066','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/3-pimple-texture_copia_2d37d6d1-aab3-4d00-89af-8afdb62b0ec8.webp?v=1759243069','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/4-pimple-ingrediente_copia_ee8b2c24-b15f-4059-a327-8c2e18b68680.webp?v=1759243060'],
    slug:'Siero anti-imperfezioni purificante', tagline:'Riduce brufoli, punti neri e pori dilatati.' },

  /* ── CONTORNO OCCHI ─────────────────────────────────────────── */
  { id:'fy_eye_cream', name:'Forever Young Lifting Eye Cream', stepLabel:'Contorno occhi',
    url:'https://skoncosmetics.com/products/forever-young-contorno-occhi-levigante-rimpolpante',
    handle:'forever-young-contorno-occhi-levigante-rimpolpante', variantId:56901212995959,
    shopVariants:[{id:56901212995959,title:'15 ml',price:2400}],
    imgs:['https://cdn.shopify.com/s/files/1/0785/8756/0209/files/FY15-gallery-01-box_1.webp?v=1774444703','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/FY15-gallery-03_3.webp?v=1777286593','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/FY15-gallery-02.webp?v=1775634221','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/FY15-gallery-04.webp?v=1775634221'],
    slug:'Contorno occhi levigante rimpolpante', tagline:'Riduce rughe, borse e occhiaie.' },

  /* staysoft_eye e staysoft_cream: aggiornati con variant ID e immagini live — 30 aprile 2026 */
  { id:'staysoft_eye', name:'Stay Soft Hydrating Eye Gel', stepLabel:'Contorno occhi',
    url:'https://skoncosmetics.com/products/stay-soft-gel-contorno-occhi-idratante-lenitivo',
    handle:'stay-soft-gel-contorno-occhi-idratante-lenitivo', variantId:57056317866359,
    shopVariants:[{id:57056317866359,title:'15 ml',price:2200}],
    imgs:['https://cdn.shopify.com/s/files/1/0785/8756/0209/files/SS15-gallery-01-box.webp?v=1777472914','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/SS15-gallery-03.webp?v=1777472924','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/SS15-gallery-02.webp?v=1777472933','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/SS15-gallery-04.webp?v=1777472946'],
    slug:'Gel contorno occhi idratante lenitivo', tagline:'Idrata e rimpolpa il contorno occhi in profondit\u00e0.' },

  /* ── CREME ───────────────────────────────────────────────────── */
  { id:'forever_young_cream', name:'Forever Young Proaging Cream', stepLabel:'Crema',
    url:'https://skoncosmetics.com/products/forever-young-crema-viso-levigante-rimpolpante',
    handle:'forever-young-crema-viso-levigante-rimpolpante', variantId:56901177180535,
    shopVariants:[{id:56901177180535,title:'40 ml',price:2600}],
    imgs:['https://cdn.shopify.com/s/files/1/0785/8756/0209/files/FY40-gallery-01-box.webp?v=1774444484','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/FY40-gallery-03.webp?v=1774444484','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/FY40-gallery-02.webp?v=1774444484','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/FY40-gallery-04.webp?v=1774444484'],
    slug:'Crema levigante rimpolpante', tagline:'Riduce rughe e linee sottili.' },

  { id:'bakuplex_crema_viso', name:'Bakuplex\u00ae Face Cream', stepLabel:'Crema',
    url:'https://skoncosmetics.com/products/bakuchiol-crema-viso-anti-age-bakuplex',
    handle:'bakuchiol-crema-viso-anti-age-bakuplex', variantId:48751055864081,
    shopVariants:[{id:48751055864081,title:'50 ml',price:3200}],
    imgs:['https://cdn.shopify.com/s/files/1/0785/8756/0209/files/BAKU-crema-gallery_1.webp?v=1769175901','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/BAKU-crema-gallery_2.webp?v=1775977684','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/BAKU-crema-gallery_3_testi.webp?v=1775977684','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/BAKU-crema-gallery_5.webp?v=1775977684'],
    slug:'Crema antiet\u00e0 globale Bakuplex\u00ae', tagline:'Rimpolpa, nutre e riduce rughe e linee sottili per una pelle visibilmente pi\u00f9 uniforme e levigata.' },

  { id:'staysoft_cream', name:'Stay Soft Comfort Cream', stepLabel:'Crema',
    url:'https://skoncosmetics.com/products/stay-soft-crema-viso-nutriente-lenitiva',
    handle:'stay-soft-crema-viso-nutriente-lenitiva', variantId:57055051481463,
    shopVariants:[{id:57055051481463,title:'40 ml',price:2400}],
    imgs:['https://cdn.shopify.com/s/files/1/0785/8756/0209/files/SS40-gallery-01-box.webp?v=1777472235','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/SS40-gallery-03.webp?v=1777472282','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/SS40-gallery-02.webp?v=1777472310','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/SS40-gallery-04.webp?v=1777472362'],
    slug:'Crema nutriente lenitiva', tagline:'Nutre, lenisce e ristora la pelle secca e sensibile.' },

  { id:'vitamin_blast', name:'Vitamin Blast', stepLabel:'Crema',
    url:'https://skoncosmetics.com/products/crema-viso-alla-vitamina-c',
    handle:'crema-viso-alla-vitamina-c', variantId:55742388732279,
    shopVariants:[{id:55742388732279,title:'30 ml',price:2400}],
    imgs:['https://cdn.shopify.com/s/files/1/0785/8756/0209/files/1-VB30-main_copia_f77c34e1-49e2-4f1e-8d57-1b3c7082d835.webp?v=1757317083','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/2-VB30-mano_copia.webp?v=1757317110','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/3-VB30-texture_copia.webp?v=1757317110','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/4-VB30-ingrediente_copia.webp?v=1757317110'],
    slug:'Crema illuminante alla Vitamina C', tagline:'Uniforma il colorito e protegge dai radicali liberi.' },

  { id:'over_the_moon', name:'Over The Moon', stepLabel:'Crema',
    url:'https://skoncosmetics.com/products/crema-viso-macchie',
    handle:'crema-viso-macchie', variantId:46950830866705,
    shopVariants:[{id:46950830866705,title:'30 ml',price:2400}],
    imgs:['https://cdn.shopify.com/s/files/1/0785/8756/0209/files/1-OM-main_copia.webp?v=1757316490','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/2-OM-mano_copia.webp?v=1757316490','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/3-OM-texture_copia.webp?v=1757316491','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/4-OM-ingrediente_copia.webp?v=1757316491'],
    slug:'Crema anti-macchia uniformante', tagline:'Riduce macchie e discromie.' },

  /* ── SPF / MAKE-UP ───────────────────────────────────────────── */
  { id:'ak_glow', name:'Abrakadabra Glow', stepLabel:'Protezione solare',
    url:'https://skoncosmetics.com/products/abrakadabra-siero-viso-fondotinta-illuminante-con-protezione-solare',
    handle:'abrakadabra-siero-viso-fondotinta-illuminante-con-protezione-solare', variantId:48718742192401,
    shopVariants:[{id:48718742192401,title:'50N Nude Porcelain',price:2500},{id:48718742225169,title:'100N Fair Ivory',price:2500},{id:48718742257937,title:'200N Natural beige',price:2500},{id:48718742356241,title:'300W Warm Olive',price:2500},{id:48718742487313,title:'300C Cool Olive',price:2500},{id:48718742782225,title:'450W Golden Tan',price:2500},{id:48718742913297,title:'600W Deep Amber',price:2500}],
    imgs:['https://cdn.shopify.com/s/files/1/0785/8756/0209/files/AK_Glow-50N.webp?v=1775715155','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/AK_Glow-GALLERY_2.webp?v=1775715155','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/AK_Glow-GALLERY_3.webp?v=1775715155','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/AK_Glow-GALLERY_5.webp?v=1775715155'],
    variantImgs:{
      48718742192401:'https://cdn.shopify.com/s/files/1/0785/8756/0209/files/AK-50N_copia_2.webp?v=1768837388',
      48718742225169:'https://cdn.shopify.com/s/files/1/0785/8756/0209/files/AK-100N_copia_2.webp?v=1768837388',
      48718742257937:'https://cdn.shopify.com/s/files/1/0785/8756/0209/files/AK-200N_copia_2.webp?v=1768837388',
      48718742356241:'https://cdn.shopify.com/s/files/1/0785/8756/0209/files/AK-300W_copia_2.webp?v=1768837387',
      48718742487313:'https://cdn.shopify.com/s/files/1/0785/8756/0209/files/AK-300C_copia_2.webp?v=1768837387',
      48718742782225:'https://cdn.shopify.com/s/files/1/0785/8756/0209/files/AK-450W_copia_2.webp?v=1768837388',
      48718742913297:'https://cdn.shopify.com/s/files/1/0785/8756/0209/files/AK-600W_copia_2.webp?v=1768837387',
    },
    slug:'Siero fondotinta illuminante SPF30', tagline:"Idrata, uniforma e illumina l'incarnato." },

  { id:'ak_matt', name:'Abrakadabra Soft Matt', stepLabel:'Protezione solare',
    url:'https://skoncosmetics.com/products/abrakadabra-siero-viso-fondotinta-opacizzante-con-protezione-solare',
    handle:'abrakadabra-siero-viso-fondotinta-opacizzante-con-protezione-solare', variantId:55043082649975,
    shopVariants:[{id:55043082649975,title:'50N Nude Porcelain',price:2500},{id:55043082682743,title:'100N Fair Ivory',price:2500},{id:55043082715511,title:'200N Natural beige',price:2500},{id:55043082748279,title:'300W Warm Olive',price:2500},{id:55043082781047,title:'300C Cool Olive',price:2500},{id:55043082813815,title:'450W Golden Tan',price:2500},{id:55043082846583,title:'600W Deep Amber',price:2500}],
    imgs:['https://cdn.shopify.com/s/files/1/0785/8756/0209/files/AK_Matt-50N.webp?v=1776074176','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/AK_Matt-GALLERY_2.webp?v=1776074176','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/AK_Matt-GALLERY_3.webp?v=1776074176','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/AK_Matt-GALLERY_5.webp?v=1776074176'],
    variantImgs:{
      55043082649975:'https://cdn.shopify.com/s/files/1/0785/8756/0209/files/AK-50N_copia_f1ab56ef-7baf-499b-9c92-d0687fb5bf0e.webp?v=1768837538',
      55043082682743:'https://cdn.shopify.com/s/files/1/0785/8756/0209/files/AK-100N_copia_d0702703-8e37-4ab6-88e2-90f1da4fa529.webp?v=1768837537',
      55043082715511:'https://cdn.shopify.com/s/files/1/0785/8756/0209/files/AK-200N_copia_832099d8-0aa7-4bcc-a690-c73b955a8fce.webp?v=1768837538',
      55043082748279:'https://cdn.shopify.com/s/files/1/0785/8756/0209/files/AK-300W_copia_6f709868-fa70-4c5e-9523-35001af57791.webp?v=1768837538',
      55043082781047:'https://cdn.shopify.com/s/files/1/0785/8756/0209/files/AK-300C_copia_135a089f-9938-4ec1-b94c-8d145272aa83.webp?v=1768837537',
      55043082813815:'https://cdn.shopify.com/s/files/1/0785/8756/0209/files/AK-450W_copia_eca381a0-bd54-471c-847f-9977b36f5fba.webp?v=1768837539',
      55043082846583:'https://cdn.shopify.com/s/files/1/0785/8756/0209/files/AK-600W_copia_77dadfe8-1a02-4e92-b449-3cddd4d3d626.webp?v=1768837538',
    },
    slug:'Siero fondotinta opacizzante SPF30', tagline:"Idrata, uniforma e assorbe l'eccesso di sebo." },

  /* ── INTEGRATORI ───────────────────────────────────────────────── */
  { id:'booster_collagene', name:'Collagen Elixir', stepLabel:'Integratore',
    url:'https://skoncosmetics.com/products/integratore-collagene-vegano',
    handle:'integratore-collagene-vegano', variantId:50094862696721,
    shopVariants:[{id:50094862696721,title:'240 gr',price:3200}],
    imgs:['https://cdn.shopify.com/s/files/1/0785/8756/0209/files/CE-gallery-01.webp?v=1774954840','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/CE-gallery-02.webp?v=1774954844','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/CE-gallery-03.webp?v=1774954849','https://cdn.shopify.com/s/files/1/0785/8756/0209/files/CE-gallery-04.webp?v=1774954853'],
    slug:'Integratore pro-collagene vegano', tagline:'Stimola la naturale produzione di Collagene.' },
];

/* ── Merge testi da SKON_TEXTS.products nel catalogo ───────────────── */
(function mergeCatalogTexts() {
  if (!window.SKON_TEXTS || !window.SKON_TEXTS.products) return;
  CATALOG.forEach(function(p) {
    var t = window.SKON_TEXTS.products[p.id];
    if (!t) return;
    if (t.slug)    p.slug    = t.slug;
    if (t.tagline) p.tagline = t.tagline;
    if (t.why)     p.why     = t.why;
  });
})();

/* ── Lookup prodotto per ID ─────────────────────────────────────────── */
var _catalogMap = null;
function getCatalogProduct(id) {
  if (!_catalogMap) {
    _catalogMap = {};
    CATALOG.forEach(function(p) { _catalogMap[p.id] = p; });
  }
  return _catalogMap[id] || null;
}

/* ══════════════════════════════════════════════════════════════════════
   FUNZIONI LOOKUP E ROUTINE (sezione 11.4 del brief)
══════════════════════════════════════════════════════════════════════ */

/* resolveProduct: applica swap globale da SKON_PRODUCT_SWAPS */
function resolveProduct(id) {
  var swaps = window.SKON_PRODUCT_SWAPS || {};
  return swaps[id] || id;
}

/* lookupRoutine: da answers → oggetto routine */
function lookupRoutine(answers) {
  var AGE_IDX    = window.AGE_INDEX    || {};
  var SKIN_IDX   = window.SKIN_INDEX   || {};
  var DESIRE_IDX = window.DESIRE_INDEX || {};
  var _LOOKUP    = window.LOOKUP       || {};
  var _ROUTINES  = window.ROUTINES     || {};

  var ageIdx    = AGE_IDX[answers.age];
  var skinIdx   = SKIN_IDX[answers.skin];
  var desireIdx = DESIRE_IDX[answers.desire];

  var code = _LOOKUP[ageIdx] && _LOOKUP[ageIdx][skinIdx] && _LOOKUP[ageIdx][skinIdx][desireIdx];
  if (!code || !_ROUTINES[code]) {
    console.warn('[skon-quiz] Lookup miss', answers, ageIdx, skinIdx, desireIdx);
    code = 'A1'; // fallback ragionevole
  }
  return Object.assign({}, _ROUTINES[code], { code: code });
}

/* applyTipsPriority: modula i 3 tips della routine con SKON_PRIORITY */
function applyTipsPriority(routineCode, defaultTips) {
  var priorities = window.SKON_PRIORITY || {};
  var forceInclude = Object.keys(priorities).filter(function(id) { return priorities[id] >= 5; });
  var forceExclude = Object.keys(priorities).filter(function(id) { return priorities[id] <= -5; });

  var tips = defaultTips.filter(function(id) { return forceExclude.indexOf(id) === -1; });

  forceInclude.forEach(function(id) {
    if (tips.indexOf(id) === -1) {
      if (tips.length < 3) { tips.push(id); }
      else { tips[tips.length - 1] = id; }
    }
  });

  return tips.slice(0, 3);
}

/* ══════════════════════════════════════════════════════════════════════
   STICKY DISCOUNT BAR (sezione 7)
══════════════════════════════════════════════════════════════════════ */
var _stickyCollapsed = true;

function renderStickyDiscountBar(isRC) {
  var bar     = document.getElementById('stickyDiscountBar');
  var content = document.getElementById('stickyDiscountContent');
  if (!bar || !content) return;

  var pct, code, tabLabel, headTitle, bodyText;
  var dc = sessionStorage.getItem('skon_discount');

  if (isRC) {
    var rcDisc = _getEffectiveRCDiscount();
    pct  = Math.round(rcDisc.pct * 100);
    code = rcDisc.code;
    dc   = dc || code;
    tabLabel  = 'Il tuo vantaggio ti aspetta qui \ud83c\udf81';
    headTitle = 'IL TUO SCONTO FEDELT\u00c0';
    bodyText  = 'Il codice <strong>' + code + '</strong> ti permette di avere il ' + pct + '% di sconto sul secondo prodotto in carrello.';
    bar.classList.add('sticky--rc');
    bar.classList.remove('sticky--nc');
  } else {
    var ncDisc = getEffectiveNewDiscount();
    pct  = Math.round(ncDisc.pct * 100);
    code = ncDisc.code;
    dc   = dc || code;
    tabLabel  = 'Il tuo vantaggio ti aspetta qui \ud83c\udf81';
    headTitle = 'HAI SBLOCCATO IL TUO SCONTO';
    bodyText  = 'Applica <strong>' + code + '</strong> al checkout e avrai il -' + pct + '% sul tuo ordine.';
    bar.classList.add('sticky--nc');
    bar.classList.remove('sticky--rc');
  }

  var catalogUrl = 'https://skoncosmetics.com/collections/catalogo?discount=' + (dc || code);

  content.innerHTML =
    '<div class="sticky-collapsed-label">'
    + '<span class="sticky-collapsed-text">' + tabLabel + '</span>'
    + '<svg class="sticky-chevron-open" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M18 15l-6-6-6 6"/></svg>'
    + '</div>'
    + '<div class="sticky-expanded-content">'
    + '<p class="sticky-head-title">' + headTitle + '</p>'
    + '<div class="sticky-code-box">'
    + '<span class="sticky-code-value" id="stickyCodeValue">' + code + '</span>'
    + '<button class="sticky-code-copy" onclick="copyStickyCode()" aria-label="Copia codice">'
    + '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/></svg>'
    + '<span id="stickyCopyLabel">Copia</span>'
    + '</button>'
    + '</div>'
    + '<p class="sticky-body">' + bodyText + '</p>'
    + '<a class="sticky-catalog-cta" href="' + catalogUrl + '">'
    + 'Scopri tutto il catalogo Sk\u00f6n \u2192'
    + '</a>'
    + '</div>';

  // Parte collassata: entra da sotto come tab
  _stickyCollapsed = true;
  bar.classList.add('is-collapsed');
  bar.style.display    = 'flex';
  bar.style.transition = 'none';
  bar.style.transform  = 'translateY(100%)';
  requestAnimationFrame(function() {
    requestAnimationFrame(function() {
      bar.style.transition = 'transform 500ms cubic-bezier(0.16, 1, 0.3, 1)';
      bar.style.transform  = 'translateY(0)';
      // Padding iniziale = altezza bar collassata, così il contenuto in fondo non è mai coperto
      var shell = document.querySelector('.quiz-shell');
      if (shell) shell.style.paddingBottom = bar.offsetHeight + 'px';
    });
  });

  _attachStickyDragHandle();

  // Padding-bottom fisso = altezza bar espansa, così il contenuto non viene mai coperto
  // Calcolato una volta sola aprendo temporaneamente la bar, poi richiudendola
  setTimeout(function() {
    var shell = document.querySelector('.quiz-shell');
    if (!shell) return;
    bar.classList.remove('is-collapsed');
    var expandedH = bar.offsetHeight;
    bar.classList.add('is-collapsed');
    shell.style.paddingBottom = expandedH + 'px';

    // Apre automaticamente la bar quando l'utente raggiunge il fondo pagina
    var sentinel = document.createElement('div');
    sentinel.id = 'stickyBarSentinel';
    sentinel.style.cssText = 'height:1px;pointer-events:none;';
    shell.appendChild(sentinel);

    var _autoOpened = false;
    var observer = new IntersectionObserver(function(entries) {
      if (entries[0].isIntersecting && _stickyCollapsed && !_autoOpened) {
        _autoOpened = true;
        _expandStickyBar();
      }
    }, { threshold: 1.0 });
    observer.observe(sentinel);
  }, 600); // dopo l'animazione di ingresso
}

function _collapseStickyBar() {
  _stickyCollapsed = true;
  var bar = document.getElementById('stickyDiscountBar');
  if (!bar) return;
  bar.style.transition = 'transform 400ms cubic-bezier(0.16, 1, 0.3, 1), background 300ms ease, border-color 300ms ease, box-shadow 300ms ease';
  bar.style.transform  = 'translateY(0)';
  setTimeout(function() { bar.classList.add('is-collapsed'); }, 50);
  // Nessun cambio di paddingBottom: rimane fisso al valore impostato all'init
}

function _expandStickyBar() {
  _stickyCollapsed = false;
  var bar = document.getElementById('stickyDiscountBar');
  if (!bar) return;
  var collapsedH = bar.offsetHeight;
  bar.classList.remove('is-collapsed');
  bar.style.transition = 'transform 400ms cubic-bezier(0.16, 1, 0.3, 1), background 200ms ease';
  bar.style.transform  = 'translateY(0)';
  // Scrolla verso l'alto della differenza tra espansa e collassata
  requestAnimationFrame(function() {
    var diff = bar.offsetHeight - collapsedH;
    if (diff > 0) window.scrollBy({ top: diff, behavior: 'smooth' });
  });
  // Tutorial gesture — solo la prima volta che la bar viene aperta
  setTimeout(_runStickyTutorial, 600);
}

function _attachStickyDragHandle() {
  var handle = document.getElementById('stickyDiscountHandle');
  var bar    = document.getElementById('stickyDiscountBar');
  if (!handle || !bar) return;

  var pill = handle.querySelector('.sticky-pill');

  var EASE      = 'cubic-bezier(0.16, 1, 0.3, 1)';
  var EASE_BACK = 'cubic-bezier(0.34, 1.56, 0.64, 1)';
  var COLLAPSE_THRESHOLD = 50;
  var EXPAND_THRESHOLD   = -30;
  var _sY = 0, _cY = 0;

  /* Feedback aptico — stessa logica degli sheet prodotto, colori su sfondo colorato */
  function _pillGrab() {
    if (!pill) return;
    pill.style.transition   = 'transform 120ms cubic-bezier(0.34,1.56,0.64,1), background 120ms';
    pill.style.transform    = 'scaleX(1.4) scaleY(0.55)';
    pill.style.background   = 'rgba(255,255,255,.75)';
    handle.style.transition = 'background 120ms cubic-bezier(0.34,1.56,0.64,1)';
    handle.style.background = 'rgba(255,255,255,.12)';
    // Vibrazione aptica al grab (Android/Chrome — no-op su iOS)
    if (navigator.vibrate) navigator.vibrate(15);
  }
  function _pillRelease() {
    if (!pill) return;
    pill.style.transition   = 'transform 200ms ' + EASE + ', background 200ms ' + EASE;
    pill.style.transform    = 'none';
    pill.style.background   = '';
    handle.style.transition = 'background 300ms ' + EASE;
    handle.style.background = '';
  }

  function _currentTranslateY() {
    var t = bar.style.transform;
    if (!t || t === 'none') return 0;
    var m = t.match(/translateY\(([^p]+)px\)/);
    return m ? parseFloat(m[1]) : 0;
  }

  handle.addEventListener('touchstart', function(e) {
    _sY = _cY = e.touches[0].clientY;
    bar.style.transition = 'none';
    _pillGrab();
  }, { passive: true });

  handle.addEventListener('touchmove', function(e) {
    _cY = e.touches[0].clientY;
    var dy   = _cY - _sY;
    var base = _currentTranslateY();
    bar.style.transform = 'translateY(' + Math.max(0, base + dy) + 'px)';
  }, { passive: true });

  handle.addEventListener('touchend', function() {
    _pillRelease();
    var dy = _cY - _sY;
    if (!_stickyCollapsed && dy > COLLAPSE_THRESHOLD) {
      _collapseStickyBar();
    } else if (_stickyCollapsed && dy < EXPAND_THRESHOLD) {
      _expandStickyBar();
    } else {
      if (_stickyCollapsed) _collapseStickyBar(); else _expandStickyBar();
    }
  }, { passive: true });

  handle.addEventListener('click', function() {
    if (_stickyCollapsed) { if (navigator.vibrate) navigator.vibrate(15); _expandStickyBar(); }
  });
  bar.addEventListener('click', function(e) {
    if (_stickyCollapsed) { if (navigator.vibrate) navigator.vibrate(15); _expandStickyBar(); e.stopPropagation(); }
  });

  var _dragging = false;
  handle.addEventListener('mousedown', function(e) {
    _dragging = true; _sY = _cY = e.clientY;
    bar.style.transition = 'none';
    _pillGrab();
  });
  document.addEventListener('mousemove', function(e) {
    if (!_dragging) return;
    _cY = e.clientY;
    bar.style.transform = 'translateY(' + Math.max(0, _currentTranslateY() + (_cY - _sY)) + 'px)';
  });
  document.addEventListener('mouseup', function() {
    if (!_dragging) return;
    _dragging = false;
    _pillRelease();
    var dy = _cY - _sY;
    if (!_stickyCollapsed && dy > COLLAPSE_THRESHOLD) _collapseStickyBar();
    else if (_stickyCollapsed && dy < EXPAND_THRESHOLD) _expandStickyBar();
    else if (_stickyCollapsed) _collapseStickyBar(); else _expandStickyBar();
  });
}

/* ══════════════════════════════════════════════════════════════════════
   NAVIGAZIONE
══════════════════════════════════════════════════════════════════════ */
function go(target) {
  if (target === 1 && (S.step === 0 || S.step === 'intro' || S.step === 'resume')) {
    trackGA4('quiz_start', { entry_point: S.step === 'resume' ? 'resume_modify' : 'intro_cta' });
  }
  if (target === 'email') {
    trackGA4('quiz_email_view', { answers_complete: Object.keys(S.answers).filter(function(k){return !!S.answers[k];}).length });
    // Attacca i listener scroll-to-CTA dopo che lo screen è visibile
    setTimeout(_attachEmailFormScrollListeners, 200);
    // Adatta la UI in base a prima visita vs ritorno
    setTimeout(function() {
      var isReturn = !!S.userEmail; // ha già inserito l'email in precedenza
      var benefitsBox = document.getElementById('emailBenefitsBox');
      var eyebrow     = document.querySelector('#s-email .eyebrow');
      var headline    = document.querySelector('#s-email .q-text');
      var subtext     = document.querySelector('#s-email .q-sub');
      var nameToggle   = document.getElementById('nameEditToggle');
      var nameInputWrap = document.getElementById('nameInputWrap');
      var btnEmailEl2  = document.getElementById('btnEmail');
      if (isReturn) {
        // Collassa il box "Cosa c'è nell'email" — l'ha già letto
        if (benefitsBox) benefitsBox.removeAttribute('open');
        // Titolo personalizzato con nome utente
        var nameStr = S.userName ? ', ' + S.userName : '';
        if (eyebrow)  eyebrow.textContent = 'Bentornata' + nameStr;
        if (headline) headline.innerHTML  = 'Conferma la tua email<br>e ricevi il nuovo protocollo';
        if (subtext)  subtext.textContent = 'Aggiorniamo il tuo profilo con le nuove risposte e ti inviamo il protocollo aggiornato.';
        // Nasconde il campo nome, mostra il link "Modifica il nome"
        if (nameInputWrap) nameInputWrap.style.display = 'none';
        if (nameToggle)    nameToggle.style.display    = 'inline-flex';
        // Cambia testo pulsante
        if (btnEmailEl2 && !btnEmailEl2.disabled) {
          btnEmailEl2.innerHTML = 'Ottieni il nuovo protocollo <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>';
        }
      } else {
        // Prima visita — box aperto, campo nome visibile, testi originali
        if (benefitsBox) benefitsBox.setAttribute('open', '');
        if (eyebrow)  eyebrow.textContent = 'Quasi pronta';
        if (headline) headline.innerHTML  = 'A chi mandiamo<br>il tuo protocollo?';
        if (subtext)  subtext.textContent = 'Il tuo protocollo è pronto. Riceverai via email i prodotti pensati per la tua pelle — con il perché di ogni scelta. E un codice sconto, per quando vorrai iniziare.';
        if (nameInputWrap) nameInputWrap.style.display = '';
        if (nameToggle)    nameToggle.style.display    = 'none';
        if (btnEmailEl2 && !btnEmailEl2.disabled) {
          btnEmailEl2.innerHTML = 'Ricevi il tuo protocollo <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>';
        }
      }
    }, 100);
  }

  var cur = S.step === 0        ? 'intro'  :
            S.step === 'resume' ? 'resume' :
            S.step === 'email'  ? 'email'  :
            S.step === 'proc'   ? 'proc'   :
            S.step === 'result' ? 'result' : S.step;
  hide('s-' + cur);
  S.stepEnteredAt = Date.now();
  S.step = target;
  var nxt = target === 0        ? 'intro'  :
            target === 'resume' ? 'resume' :
            target === 'email'  ? 'email'  :
            target === 'proc'   ? 'proc'   :
            target === 'result' ? 'result' : target;
  show('s-' + nxt);
  updateUI();
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

function confirmResume() {
  trackGA4('quiz_resume_confirm', { answers_count: _countAnswers(S.answers), age_range: S.answers.age || '' });
  go('email');
}
function modifyResume() {
  trackGA4('quiz_resume_modify', { answers_count: _countAnswers(S.answers) });
  _preSelectAnswers(S.answers);
  go(1);
}

function show(id) {
  var el = document.getElementById(id);
  if (el) { el.classList.remove('active'); void el.offsetWidth; el.classList.add('active'); }
}
function hide(id) {
  var el = document.getElementById(id);
  if (el) el.classList.remove('active');
}

function updateUI() {
  var pct = S.step === 0        ? 0  :
            S.step === 'resume' ? 5  :
            S.step === 'email'  ? 88 :
            S.step === 'proc'   ? 95 :
            S.step === 'result' ? 100 : (S.step / TOTAL) * 82;
  var bar = document.getElementById('bar');
  if (bar) bar.style.width = pct + '%';
  var lbl = document.getElementById('stepLabel');
  if (!lbl) return;
  if (S.step === 0 || S.step === 'result' || S.step === 'resume') lbl.textContent = '';
  else if (S.step === 'email') lbl.textContent = 'Ultimo passo';
  else if (typeof S.step === 'number') lbl.textContent = S.step + ' / ' + TOTAL;
  else lbl.textContent = '';
}

/* ── pick() ─────────────────────────────────────────────────────────── */
function pick(el, key, val) {
  el.closest('.opts').querySelectorAll('.opt').forEach(function(o) {
    o.classList.remove('selected'); o.classList.remove('pulse');
  });
  el.classList.add('selected');
  S.answers[key] = val;
  _saveProgress();

  var _stepNames = { age:'eta', skin:'tipo_pelle', desire:'desiderio', spf:'protezione_solare' };
  trackGA4('quiz_step', {
    step_number:  typeof S.step === 'number' ? S.step : 0,
    step_key:     key,
    step_name:    _stepNames[key] || key,
    answer_value: val,
    time_on_step: S.stepEnteredAt ? Math.round((Date.now() - S.stepEnteredAt) / 1000) : 0,
  });

  var step = S.step;
  if (typeof step === 'number' && step > 0) {
    var btn = document.getElementById('b' + step);
    if (btn) btn.classList.remove('off');
  }
  void el.offsetWidth;
  el.classList.add('pulse');
  var nextStep = (typeof step === 'number' && step > 0) ? step + 1 : null;
  if (nextStep !== null) {
    var dest = (step === 4) ? 'email' : nextStep;
    setTimeout(function() { go(dest); }, 380);
  }
}

/* ── Scroll verso il pulsante CTA al focus su un campo del form email ── */
function _scrollToBtnEmail() {
  var btn = document.getElementById('btnEmail');
  if (!btn) return;
  // Piccolo delay per aspettare che la tastiera virtuale si sia aperta
  setTimeout(function() {
    btn.scrollIntoView({ behavior: 'smooth', block: 'end' });
  }, 350);
}
function _attachEmailFormScrollListeners() {
  ['emailIn', 'nameIn', 'privacyBox'].forEach(function(id) {
    var el = document.getElementById(id);
    if (!el) return;
    var evt = (el.type === 'checkbox') ? 'change' : 'focus';
    el.addEventListener(evt, _scrollToBtnEmail, { once: false });
  });
}

/* ── checkForm() ─────────────────────────────────────────────────────── */
function checkForm() {
  var emEl = document.getElementById('emailIn');
  var em   = emEl ? emEl.value : '';
  var ok   = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em);
  var prv  = document.getElementById('privacyBox').checked;

  document.getElementById('emailErr').classList.toggle('show', em.length > 3 && !ok);
  document.getElementById('btnEmail').classList.toggle('off', !(ok && prv));

  var nm = document.getElementById('nameIn');
  if (nm) S.userName = nm.value.trim().split(' ')[0] || '';

  // Se l'email non è valida (utente sta modificando) e c'era già un check precedente
  // → resetta subito banner e nome auto-compilato senza aspettare il debounce
  if (!ok && _lastCheckedEmail) {
    _clearNameAutofillBanner();
    if (nm && nm.dataset && nm.dataset.autofilled === '1') {
      nm.value = '';
      nm.dataset.autofilled = '';
      S.userName = '';
    }
    _lastCheckedEmail = '';
    clearTimeout(_crmCheckTimer);
  }

  if (ok) _triggerCRMCheck(em);
}

/* ── CRM check: si attiva appena la regex valida l'email ──────────────── */
var _lastCheckedEmail = '';
var _crmCheckTimer    = null;
function _triggerCRMCheck(email) {
  // Email diversa dall'ultima già processata → reset banner e nome auto-compilato
  if (_lastCheckedEmail && email !== _lastCheckedEmail) {
    _clearNameAutofillBanner();
    var nmR = document.getElementById('nameIn');
    if (nmR && nmR.dataset && nmR.dataset.autofilled === '1') {
      nmR.value = '';
      nmR.dataset.autofilled = '';
      S.userName = '';
    }
    _lastCheckedEmail = ''; // forza riesecuzione
  }
  if (email === _lastCheckedEmail) return;
  clearTimeout(_crmCheckTimer);
  _crmCheckTimer = setTimeout(function() {
    _lastCheckedEmail = email;
    _checkCRMProfile(email);
  }, 350);
}

/* ── onEmailBlur() — manteniamo per compatibilità ma la logica è in checkForm ── */
function onEmailBlur() {
  var em = document.getElementById('emailIn').value.trim();
  if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em)) _triggerCRMCheck(em);
}

/* Adattatore CRM agnostico — sostituire l'implementazione per cambiare CRM */
async function _checkCRMProfile(email) {
  try {
    var res = await fetch('https://skon-quiz-check-magnews.admins-e7e.workers.dev/check-customer', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email }),
      signal: AbortSignal.timeout(4000),
    });
    if (!res.ok) return;
    var data = await res.json();

    // Auto-fill nome se disponibile e campo ancora vuoto
    if (data.firstName) {
      var nameIn = document.getElementById('nameIn');
      if (nameIn && !nameIn.value.trim()) {
        nameIn.value = data.firstName;
        if (nameIn.dataset) nameIn.dataset.autofilled = '1';
        S.userName   = data.firstName;
        _showNameAutofillBanner(data.firstName);
      }
    }

    // Pre-assegna sconto RC se è un cliente esistente
    if (data.isCustomer) {
      try { sessionStorage.setItem('skon_discount', _getEffectiveRCDiscount().code); } catch(e) {}
    }
  } catch(e) { /* timeout o errore di rete — flusso normale */ }
}

/* Banner arancio sopra il campo nome */
function _showNameAutofillBanner(firstName) {
  _clearNameAutofillBanner();
  var nameWrap = document.getElementById('nameFieldWrap');
  if (!nameWrap) return;
  // Title con nome in uppercase (es. 'CHE BELLO RIVEDERTI, MATTEO!')
  // Fallback safe: se firstName manca, niente virgola + nome.
  var nameSuffix = '';
  if (firstName && typeof firstName === 'string' && firstName.trim()) {
    nameSuffix = ', ' + firstName.trim().toUpperCase() + '!';
  }
  var banner = document.createElement('div');
  banner.id = 'nameAutofillBanner';
  banner.className = 'name-autofill-banner';
  banner.innerHTML =
    '<strong class="name-autofill-title">CHE BELLO RIVEDERTI' + nameSuffix + '</strong>'
    + '<span class="name-autofill-body">Ci conosciamo gi\u00e0! \u00c8 corretto il tuo nome? \ud83d\udc47</span>';
  nameWrap.insertBefore(banner, nameWrap.firstChild);
}

function _clearNameAutofillBanner() {
  var existing = document.getElementById('nameAutofillBanner');
  if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
}

/* ── submitEmail() ───────────────────────────────────────────────────── */
// ─── Utility: data/ora corrente nel fuso orario italiano ────────────────────
// Formato: "dd/MM/yyyy HH:mm:ss" — accettato dai campi Data/Ora di Magnews.
function nowItalianTime() {
  var now = new Date();
  var parts = new Intl.DateTimeFormat('it-IT', {
    timeZone: 'Europe/Rome',
    day:    '2-digit',
    month:  '2-digit',
    year:   'numeric',
    hour:   '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).formatToParts(now);
  var p = {};
  parts.forEach(function(x) { p[x.type] = x.value; });
  return p.day + '/' + p.month + '/' + p.year + ' ' + p.hour + ':' + p.minute + ':' + p.second;
}

// ─── Utility: converte qualsiasi formato data in "dd/MM/yyyy HH:mm:ss" (Magnews) ──
// Gestisce valori legacy in formato ISO (2026-04-30T13:30:00.000Z) salvati
// nel localStorage da versioni precedenti del quiz.
function sanitizeDateForMagnews(val) {
  if (!val) return nowItalianTime();
  // Se è già nel formato Magnews (dd/MM/yyyy) non toccare
  if (/^\d{2}\/\d{2}\/\d{4}/.test(val)) return val;
  // Altrimenti è ISO — converto in ora italiana
  try {
    var d = new Date(val);
    if (isNaN(d.getTime())) return nowItalianTime();
    var parts = new Intl.DateTimeFormat('it-IT', {
      timeZone: 'Europe/Rome',
      day: '2-digit', month: '2-digit', year: 'numeric',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      hour12: false,
    }).formatToParts(d);
    var p = {};
    parts.forEach(function(x) { p[x.type] = x.value; });
    return p.day + '/' + p.month + '/' + p.year + ' ' + p.hour + ':' + p.minute + ':' + p.second;
  } catch(e) { return nowItalianTime(); }
}

async function submitEmail() {
  // Disabilita subito il pulsante per evitare doppi invii
  var _submitBtn = document.getElementById('btnEmail');
  if (_submitBtn) {
    _submitBtn.disabled = true;
    _submitBtn.textContent = 'Attendere…';
    _submitBtn.style.background   = 'rgba(31,88,66,0.35)';
    _submitBtn.style.color        = 'rgba(255,255,255,0.70)';
    _submitBtn.style.cursor       = 'not-allowed';
    _submitBtn.style.boxShadow    = 'none';
  }

  var email = document.getElementById('emailIn').value.trim();
  S.userEmail = email;
  var name  = document.getElementById('nameIn').value.trim();
  var parts = name.split(' ');
  window.SKON_USER_NAME = name;

  // 1. Lookup routine
  var routine     = lookupRoutine(S.answers);
  var routineCode = routine.code;
  var profileLetter = routine.profileLetter || 'A';
  S.routineCode   = routineCode;

  // 2. Applica swap globale e priority tips
  var rawCore = routine.core.map(resolveProduct);
  var rawTips = routine.tips.map(resolveProduct);
  var finalTips = applyTipsPriority(routineCode, rawTips);
  var finalCore = rawCore;

  // 3. GA4 routine assigned
  trackGA4('quiz_routine_assigned', {
    routine_code:   routineCode,
    profile_letter: profileLetter,
    age:            S.answers.age    || '',
    skin:           S.answers.skin   || '',
    desire:         S.answers.desire || '',
    spf_habit:      S.answers.spf    || '',
  });

  // 4. Verifica NC/RC via Cloudflare Worker
  var discountCode = getEffectiveNewDiscount().code;
  try {
    discountCode = await getDiscountCode(email);
    try { sessionStorage.setItem('skon_discount', discountCode); } catch(e) {}
  } catch(e) {}

  var isRC = (discountCode === _getEffectiveRCDiscount().code);
  S.isReturningCustomer = isRC;

  // 5. Applica sconto in sessione
  await applyDiscount(discountCode);
  go('proc');

  // 6. Processing screen
  var procTitle = document.getElementById('procTitle');
  var procSub   = document.getElementById('procSub');
  if (procTitle) procTitle.textContent = 'Stiamo elaborando\u2026';
  if (procSub) {
    var greet = S.userName ? S.userName + ', s' : 'S';
    procSub.textContent = greet + 'tiamo costruendo il tuo protocollo. Un secondo.';
  }

  // 7. Payload CRM neutro (CRM-agnostic)
  var spfHabit = S.answers.spf || '';
  // v3.1.0 — heroProductId per branch E2 Magnews (6 varianti su QUIZ_HERO_PRODUCT).
  // Source: SkonRoutine.get factory-resolved (rispetta heroOverride v1.6.0 del
  // logic-data, NON la versione raw window.ROUTINES che lookupRoutine restituisce).
  // Fallback safe a stringa vuota: branch Magnews su QUIZ_HERO_PRODUCT='' diventa
  // fallback default (gestire nel template Magnews con un mn:else di sicurezza).
  var heroProductId = '';
  try {
    if (window.SkonRoutine && typeof window.SkonRoutine.get === 'function') {
      var rFull = window.SkonRoutine.get(routineCode);
      heroProductId = (rFull && rFull.heroProduct && rFull.heroProduct.id) || '';
    }
  } catch (e) {
    heroProductId = '';
  }
  var userProfile = {
    // Identificazione
    email:      email,
    first_name: parts[0] || '',
    last_name:  parts.slice(1).join(' ') || '',
    // Risposte raw (4 campi)
    quiz_age:           S.answers.age    || '',
    quiz_skin_self:     S.answers.skin   || '',
    quiz_desire:        S.answers.desire || '',
    quiz_spf_habit:     spfHabit,
    // Output diagnostico
    quiz_routine_code:   routineCode,
    quiz_routine_title:  routine.title || '',
    quiz_profile_letter: profileLetter,
    quiz_hero_product:   heroProductId,  // v3.1.0 — per branch E2 Magnews su 6 varianti
    // Interest flags (segmenti Magnews)
    quiz_interest_proaging:   profileLetter === 'A',
    quiz_interest_idrata:     profileLetter === 'B',
    quiz_interest_imperfect:  profileLetter === 'C',
    quiz_interest_luminosita: profileLetter === 'D',
    quiz_interest_spf:        (spfHabit === 'sempre' || spfHabit === 'a_volte'),
    // Slot prodotti (per email) — ID catalogo
    quiz_core_1: finalCore[0] || '',
    quiz_core_2: finalCore[1] || '',
    quiz_core_3: finalCore[2] || '',
    quiz_core_4: finalCore[3] || '',
    // Handle Shopify corrispondenti (per link e immagini nelle email Magnews)
    quiz_core_1_handle: (getCatalogProduct(finalCore[0]) || {}).handle || '',
    quiz_core_2_handle: (getCatalogProduct(finalCore[1]) || {}).handle || '',
    quiz_core_3_handle: (getCatalogProduct(finalCore[2]) || {}).handle || '',
    quiz_core_4_handle: (getCatalogProduct(finalCore[3]) || {}).handle || '',
    // E1 card prodotti — delegato a SKON_EMAIL.buildProductsHtml
    // (single source of truth SkonRoutine). Stesso pattern fallback-safe
    // di quiz_email_routine_html e quiz_email_e1_html.
    quiz_email_products_html: (window.SKON_EMAIL && typeof window.SKON_EMAIL.buildProductsHtml === 'function')
      ? window.SKON_EMAIL.buildProductsHtml(routineCode, {
          name:         S.userName || '',
          discountCode: discountCode,
          discountPct:  Math.round((isRC ? _getEffectiveRCDiscount().pct : getEffectiveNewDiscount().pct) * 100),
          isRC:         isRC,
        })
      : '',
    // E4 "Come usare la tua routine": delegato a SKON_EMAIL.buildRoutineHtml
    // (single source of truth SkonRoutine, narrativa mattino/sera verbatim Clio).
    // Stesso pattern fallback-safe di quiz_email_e1_html.
    quiz_email_routine_html: (window.SKON_EMAIL && typeof window.SKON_EMAIL.buildRoutineHtml === 'function')
      ? window.SKON_EMAIL.buildRoutineHtml(routineCode, {
          name:         S.userName || '',
          discountCode: discountCode,
          discountPct:  Math.round((isRC ? _getEffectiveRCDiscount().pct : getEffectiveNewDiscount().pct) * 100),
          isRC:         isRC,
        })
      : '',
    // ── E1 maincontent — generato da skon-quiz-email-content.js ──────────────
    // Fallback safe: se l'asset non è ancora caricato (race condition improbabile
    // dato l'ordine 'defer'), il campo resta stringa vuota e Magnews mostrerebbe
    // un maincontent vuoto. Da monitorare in fase di rollout.
    // v3.0.0: nuova firma (routineCode, customer). Lo shim retrocompat è stato
    // rimosso da email-content v2.10.0 — deploy atomico obbligatorio.
    quiz_email_e1_html: (window.SKON_EMAIL && typeof window.SKON_EMAIL.buildE1 === 'function')
      ? window.SKON_EMAIL.buildE1(routineCode, {
          name:         S.userName || '',
          age:          S.answers.age || '',
          spfInterest:  (spfHabit === 'sempre' || spfHabit === 'a_volte'),
          discountCode: discountCode,
          discountPct:  Math.round((isRC ? _getEffectiveRCDiscount().pct : getEffectiveNewDiscount().pct) * 100),
          isRC:         isRC,
        })
      : '',
    quiz_tip_1:  finalTips[0] || '',
    quiz_tip_2:  finalTips[1] || '',
    quiz_tip_3:  finalTips[2] || '',
    // Retrocompatibilità chiavi esistenti
    quiz_completed:           true,
    quiz_date:                nowItalianTime(),
    quiz_skin_type:           S.answers.skin   || '',
    quiz_age_range:           S.answers.age    || '',
    quiz_recommended_products: finalCore.concat(finalTips).join(','),
    quiz_discount_code:       discountCode,
    quiz_discount_pct:        isRC ? _getEffectiveRCDiscount().pct : getEffectiveNewDiscount().pct,
    quiz_discount_group:      getDiscountGroup(),
    quiz_updated_at:          nowItalianTime(),
    quiz_discount_assigned:   discountCode,
  };

  // Lifecycle quiz
  try {
    var existing = JSON.parse(localStorage.getItem('skon_quiz_result') || 'null');
    userProfile.quiz_first_completed_at  = (existing && existing.firstCompletedAt)
      ? sanitizeDateForMagnews(existing.firstCompletedAt)
      : nowItalianTime();
    userProfile.quiz_last_completed_at   = nowItalianTime();
    userProfile.quiz_completion_count    = existing ? ((existing.completionCount || 1) + 1) : 1;
    userProfile.quiz_is_repeat_completion = !!existing;
    userProfile.quiz_previous_routine_code = existing ? (existing.routineCode || null) : null;
    userProfile.quiz_routine_changed     = existing ? (existing.routineCode !== routineCode) : false;
  } catch(e) {
    userProfile.quiz_first_completed_at  = nowItalianTime();
    userProfile.quiz_last_completed_at   = nowItalianTime();
    userProfile.quiz_completion_count    = 1;
    userProfile.quiz_is_repeat_completion = false;
    userProfile.quiz_previous_routine_code = null;
    userProfile.quiz_routine_changed     = false;
  }

  // 8. Magnews subscription (via Worker Cloudflare)
  try {
    await fetch('https://skon-quiz-check-magnews.admins-e7e.workers.dev/subscribe', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email:              email,
        properties:         userProfile,
        isExistingCustomer: isRC,
      })
    });
  } catch(e) { console.error('[skon-quiz] Magnews subscribe error:', e); }

  await new Promise(function(r) { setTimeout(r, 3000); });

  // 9. Meta Pixel Lead
  trackQuizLead(email, routineCode, profileLetter, finalCore.concat(finalTips)).catch(function(){});

  // 9b. Meta Pixel custom event QuizCompleted — property denormalizzate per
  //     Custom Audience Meta (vedi trackQuizCompletedEvent docblock).
  //     Chiamato DOPO trackQuizLead → eredita advanced matching email.
  trackQuizCompletedEvent({
    routineCode:    routineCode,
    profileLetter:  profileLetter,
    isRC:           isRC,
    ageRange:       S.answers.age    || '',
    skinSelf:       S.answers.skin   || '',
    desire:         S.answers.desire || '',
    spfHabit:       spfHabit,
    spfInterest:    (spfHabit === 'sempre' || spfHabit === 'a_volte'),
    discountGroup:  getDiscountGroup(),
    coreIds:        finalCore,
    tipIds:         finalTips,
  });

  // 10. Cookie di output
  _setCookie('skon_quiz_completed', '1', 60);
  _setCookie('skon_quiz_group', getDiscountGroup(), 60);
  _setCookie('skon_quiz_profile', routineCode + '|' + (S.answers.skin || '') + '|' + (S.answers.age || ''), 60);

  // 11. localStorage skon_quiz_result (letto da nc-experience.js)
  _clearProgress();
  try {
    var _userName = (window.SKON_USER_NAME || '').trim().split(' ')[0] || '';
    var _existingResult = JSON.parse(localStorage.getItem('skon_quiz_result') || 'null');
    localStorage.setItem('skon_quiz_result', JSON.stringify({
      ts:                  Date.now(),
      name:                _userName,
      // ── campi letti da nc-experience.js (NON RINOMINARE) ──
      pct:                 isRC ? _getEffectiveRCDiscount().pct : getEffectiveNewDiscount().pct,
      code:                discountCode,
      group:               getDiscountGroup(),
      protocol:            finalCore.concat(finalTips),  // array 7 ID per badge protocollo
      // ── nuovi campi ──
      routineCode:         routineCode,
      routineTitle:        routine.title || '',
      profileLetter:       profileLetter,
      core:                finalCore,
      tips:                finalTips,
      spfHabit:            spfHabit,
      age:                 S.answers.age    || '',
      skin:                S.answers.skin   || '',
      desire:              S.answers.desire || '',
      spf:                 S.answers.spf    || '',
      isFirstCompletion:   !_existingResult,
      completionCount:     _existingResult ? ((_existingResult.completionCount || 1) + 1) : 1,
      previousRoutineCode: _existingResult ? (_existingResult.routineCode || null) : null,
      routineChanged:      _existingResult ? (_existingResult.routineCode !== routineCode) : false,
      firstCompletedAt:    _existingResult ? sanitizeDateForMagnews(_existingResult.firstCompletedAt || nowItalianTime()) : nowItalianTime(),
    }));
  } catch(e) {}

  // 12. Render pagina risultato
  renderResult(finalCore, finalTips, routine, isRC);
  go('result');
  _removeAbandonTracking();
  setTimeout(_showDiscountIntro, 400);

  // 13. GA4 + Meta Pixel ViewContent
  trackGA4('quiz_result_view', {
    routine_code:    routineCode,
    profile_letter:  profileLetter,
    protocol_ids:    finalCore.concat(finalTips).join(','),
    protocol_length: finalCore.length + finalTips.length,
  });
  trackGA4('quiz_complete', {
    routine_code:   routineCode,
    profile_letter: profileLetter,
    discount_group: getDiscountGroup(),
    protocol_length: finalCore.length + finalTips.length,
  });
  if (typeof window.fbq === 'function') {
    window.fbq('track', 'ViewContent', {
      content_type:     'product',
      content_ids:      finalCore.concat(finalTips),
      content_name:     'Protocollo skin test: ' + routineCode,
      content_category: profileLetter,
      num_items:        finalCore.length + finalTips.length,
    });
  }

  // 14. Sticky bar sconto
  renderStickyDiscountBar(isRC);
}

/* ── renderResult() ──────────────────────────────────────────────────── */
function renderResult(coreIds, tipsIds, routine, isRC) {
  // Titolo e intro routine
  var titleEl = document.getElementById('rTitle');
  var introEl = document.getElementById('rRoutineIntro');
  if (titleEl) titleEl.textContent = routine.title || '';
  if (introEl) {
    var greeting = S.userName
      ? S.userName + ', abbiamo creato per te una skincare routine completa'
      : 'Abbiamo creato per te una skincare routine completa';
    var introText = routine.intro || '';
    introEl.textContent = introText.replace(
      'Abbiamo creato per te una skincare routine completa',
      greeting
    );
  }

  // Header sezione core — sovrascrive il fallback SSR del Liquid
  var coreHeaderEl = document.getElementById('rCoreHeader');
  if (coreHeaderEl) coreHeaderEl.textContent = _t('coreSectionHeader');

  // Header sezione tips — sovrascrive il fallback SSR del Liquid
  var tipsHeaderEl = document.getElementById('rTipsHeader');
  if (tipsHeaderEl) tipsHeaderEl.textContent = _t('tipsSectionHeader');

  // Render card core (4 prodotti)
  var coreContainer = document.getElementById('rCoreCards');
  if (coreContainer) {
    coreContainer.innerHTML = '';
    coreIds.forEach(function(id, idx) {
      var resolvedId = resolveProduct(id);
      var prod = getCatalogProduct(resolvedId);
      if (!prod) return;
      coreContainer.appendChild(_buildProductCard(prod, idx, 'core', idx + 1));
    });
  }

  // CTA "Aggiungi tutta la routine al carrello" sotto le 4 card core
  _renderAddAllRoutineCta(coreIds);

  // Render card tips (3 prodotti)
  var tipsContainer = document.getElementById('rTipsCards');
  if (tipsContainer) {
    tipsContainer.innerHTML = '';
    tipsIds.forEach(function(id, idx) {
      var resolvedId = resolveProduct(id);
      var prod = getCatalogProduct(resolvedId);
      if (!prod) return;
      tipsContainer.appendChild(_buildProductCard(prod, idx, 'tip', idx + 1));
    });
  }

  addRestartButton();

  // Applica codice sconto a tutti i link della pagina risultati
  setTimeout(function() {
    var dc = sessionStorage.getItem('skon_discount') || DISCOUNT_CONFIG.newCode;
    _patchAllResultLinks(dc);
  }, 200);
}

/* Costruisce una card prodotto (core o tip) */
function _buildProductCard(prod, idx, section, stepNum) {
  var div = document.createElement('div');
  div.className = 'prod-card prod-card--' + section;

  // Immagine
  var imgHtml = '';
  if (prod.imgs && prod.imgs.length > 0) {
    imgHtml = '<div class="prod-image" onclick="openDetailSheet(\'' + prod.id + '\')" style="cursor:pointer">'
      + '<img src="' + prod.imgs[0] + '" alt="' + prod.name + '" onerror="this.style.display=\'none\'">'
      + '</div>';
  }

  // Step/tip label con titolo categoria
  var stepLabelText = prod.stepLabel || '';
  var stepPrefix = section === 'core' ? _t('stepLabelCore') : _t('stepLabelTip');
  var stepClass  = section === 'core' ? 'prod-step--core' : 'prod-step--tip';
  var stepHtml = '<div class="prod-step ' + stepClass + '">' + stepPrefix + ' ' + stepNum
               + (stepLabelText ? ' \u2014 ' + stepLabelText.toUpperCase() : '') + '</div>';

  // Box "perché per te"
  var nameLabel = S.userName ? ', ' + S.userName : '';
  var whyText   = prod.why || prod.tagline || '';
  // whyHtml ora inline nel div con onclick

  // Bottoni affiancati
  var btnRow = '<div class="prod-btn-row">'
    + '<button class="prod-btn-view" onclick="openDetailSheet(\'' + prod.id + '\')">' + _t('btnViewProduct') + '</button>'
    + '<button class="prod-btn-interest" id="ibtn-' + prod.id + '" onclick="handleInterest(\'' + prod.id + '\', this)">' + _t('btnInterested') + '</button>'
    + '</div>';

  div.innerHTML = imgHtml
    + '<div class="prod-info">'
    + stepHtml
    + '<p class="prod-name" onclick="openDetailSheet(\'' + prod.id + '\')" style="cursor:pointer">' + prod.name + '</p>'
    + '<p class="prod-subtitle" onclick="openDetailSheet(\'' + prod.id + '\')" style="cursor:pointer">' + prod.slug + '</p>'
    + (whyText
      ? '<div class="prod-why-you" onclick="openDetailSheet(\'' + prod.id + '\')" style="cursor:pointer"><span class="prod-why-you-label">' + _t('whyForYouLabel') + nameLabel + '</span><span class="prod-why-you-text">' + whyText + '</span></div>'
      : '')
    + btnRow
    + '</div>';

  // Dati prodotto sul bottone interesse
  setTimeout(function() {
    var interestBtn = document.getElementById('ibtn-' + prod.id);
    if (interestBtn) {
      var _sv = prod.shopVariants && prod.shopVariants.length > 0
        ? prod.shopVariants
        : [{ id: prod.variantId, title: 'Acquista', price: 0 }];
      interestBtn._prod = Object.assign({}, prod, { _variants: _sv, _section: section });
    }
  }, 0);

  return div;
}

/* ══════════════════════════════════════════════════════════════════════
   addAllToCart(section): CTA "Aggiungi tutta la routine" → checkout
   ──────────────────────────────────────────────────────────────────────
   Flow (v2.4.0):
   1. Resetta innerHTML del bottone e imposta "Aggiungo…"
   2. Loop seriale di fetch /cart/add.js per i N prodotti
   3. await applyDiscount(dc) — applica codice in sessione Shopify
   4. Se TUTTI gli add hanno avuto successo:
      → Mostra toast 'Routine aggiunta — vai al checkout' per 2s
      → window.location.href = /discount/CODE?redirect=/checkout
   5. Se errorCount > 0:
      → Mostra toast di errore parziale, NIENTE redirect
      → L'utente resta sulla pagina per riprovare manualmente

   Il pattern /discount/CODE?redirect=/checkout riapplica il codice
   anche se la sessione è invalida o scaduta (Shopify ufficiale).
══════════════════════════════════════════════════════════════════════ */
async function addAllToCart(section) {
  var btn = document.getElementById('btnAdd' + (section === 'core' ? 'Routine' : 'Tips'));
  if (btn) {
    btn.disabled = true;
    btn.innerHTML = _t('ctaAddingShort'); // pulisce CTA + sub-line precedenti
  }

  var resultData = null;
  try { resultData = JSON.parse(localStorage.getItem('skon_quiz_result') || 'null'); } catch(e) {}
  var ids = section === 'core'
    ? (resultData ? resultData.core : [])
    : (resultData ? resultData.tips : []);

  var errorCount = 0;
  for (var i = 0; i < ids.length; i++) {
    var id = resolveProduct(ids[i]);
    var prod = getCatalogProduct(id);
    if (!prod || !prod.variantId) { errorCount++; continue; }
    try {
      var r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: prod.variantId, quantity: 1 }] })
      });
      if (!r.ok) errorCount++;
    } catch(e) { errorCount++; }
  }

  var dc = sessionStorage.getItem('skon_discount') || DISCOUNT_CONFIG.newCode;
  await applyDiscount(dc);
  _notifyCartUpdate();

  // Tracking GA4 (sempre, anche su errore parziale per analytics)
  trackGA4('add_to_cart_from_quiz', {
    source_section:    section,
    is_routine_bundle: true,
    items_added:       ids.length - errorCount,
    items_total:       ids.length,
  });

  if (errorCount === 0) {
    // SUCCESSO: toast 2s + redirect al checkout con codice pre-applicato
    var checkoutUrl = '/discount/' + encodeURIComponent(dc) + '?redirect=/checkout';
    _showCheckoutRedirectToast(_t('toastRoutineAdded'), 2000, checkoutUrl);
    // Tengo il bottone disabled (l'utente sta per essere reindirizzato)
  } else {
    // FALLIMENTO PARZIALE: toast errore, niente redirect, bottone riprovabile
    _showCheckoutRedirectToast(
      _t('toastRoutineError', { ok: ids.length - errorCount, total: ids.length }),
      3500,
      null // null = no redirect
    );
    if (btn) {
      btn.disabled = false;
      btn.textContent = _t('cartAddedPartial', { ok: ids.length - errorCount, total: ids.length });
      setTimeout(function() {
        btn.textContent = section === 'core' ? _t('ctaAddRoutine') : _t('ctaAddTips');
      }, 4000);
    }
  }
}

/* ══════════════════════════════════════════════════════════════════════
   _showCheckoutRedirectToast(msg, delayMs, redirectUrl)
   ──────────────────────────────────────────────────────────────────────
   Toast overlay bottom-center con messaggio personalizzato.
   - Fade-in 300ms, mantiene il testo per delayMs, fade-out 300ms.
   - Se redirectUrl è passato, fa window.location.href dopo delayMs - 200ms
     (il browser inizia la navigazione mentre il toast è ancora visibile).
   - Stile inline: niente dipendenze CSS esterne.
══════════════════════════════════════════════════════════════════════ */
function _showCheckoutRedirectToast(msg, delayMs, redirectUrl) {
  // Rimuove eventuale toast precedente
  var existing = document.getElementById('skonCheckoutToast');
  if (existing) existing.parentNode.removeChild(existing);

  var toast = document.createElement('div');
  toast.id = 'skonCheckoutToast';
  toast.style.cssText = [
    'position:fixed',
    'bottom:30px',
    'left:50%',
    'transform:translateX(-50%) translateY(20px)',
    'z-index:9999',
    'background:var(--green, #1f5842)',
    'color:#fff',
    'padding:14px 28px',
    'border-radius:9999px',
    'font-family:\'Jost\', sans-serif',
    'font-size:14px',
    'font-weight:600',
    'letter-spacing:0.02em',
    'box-shadow:0 8px 24px rgba(0,0,0,.18)',
    'display:flex',
    'align-items:center',
    'gap:10px',
    'opacity:0',
    'transition:opacity 300ms ease, transform 300ms cubic-bezier(0.16, 1, 0.3, 1)',
    'pointer-events:none',
    'max-width:calc(100vw - 32px)',
    'text-align:center',
  ].join(';');

  // Icona check
  toast.innerHTML =
    '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">'
    + '<polyline points="20 6 9 17 4 12"/></svg>'
    + '<span>' + msg + '</span>';

  document.body.appendChild(toast);

  // Fade-in dopo 1 frame
  requestAnimationFrame(function() {
    toast.style.opacity = '1';
    toast.style.transform = 'translateX(-50%) translateY(0)';
  });

  // Schedule del redirect (se richiesto) + fade-out
  setTimeout(function() {
    toast.style.opacity = '0';
    toast.style.transform = 'translateX(-50%) translateY(20px)';
  }, Math.max(0, delayMs - 300));

  if (redirectUrl) {
    setTimeout(function() {
      window.location.href = redirectUrl;
    }, delayMs);
  } else {
    // No redirect: rimuovi il toast dopo l'animazione di uscita
    setTimeout(function() {
      if (toast.parentNode) toast.parentNode.removeChild(toast);
    }, delayMs + 50);
  }
}

/* ══════════════════════════════════════════════════════════════════════
   Bottone "Aggiungi tutta la routine al carrello" (v2.3.4+, fix v2.3.7)
   ──────────────────────────────────────────────────────────────────────
   Renderizzato sotto le 4 card core nella schermata risultato.
   CTA + sub-line con prezzo totale, identico stile al varConfirmBtn del
   variant sheet (var-btn-primary + cart-btn-sub).

   Sub-line dinamica:
     - NC: '<s>orig</s> → discounted (-PCT%)' (prezzo calcolato dai 4 core)
     - RC: 'Lo sconto si applica automaticamente al carrello' (placeholder v2.6+)

   Al click chiama addAllToCart('core') — la funzione legge gli ID dei 4 core
   raccomandati da localStorage.skon_quiz_result.core (salvati al render
   result), li risolve via resolveProduct() per gli A/B test, e li aggiunge
   uno a uno via /cart/add.js applicando lo sconto attivo.
══════════════════════════════════════════════════════════════════════ */

function _renderAddAllRoutineCta(coreIds) {
  var coreSection = document.querySelector('.result-core-section');
  if (!coreSection) return;

  // Rimuove eventuale bottone precedente per evitare duplicati al re-render
  var existing = coreSection.querySelector('.add-all-routine-wrap');
  if (existing) existing.parentNode.removeChild(existing);

  // Calcola prezzo totale della routine (somma price della prima variante di ogni core)
  var totalCents = 0;
  var validCount = 0;
  coreIds.forEach(function(id) {
    var prod = getCatalogProduct(resolveProduct(id));
    if (!prod) return;
    var v = (prod.shopVariants && prod.shopVariants[0]) || null;
    if (v && v.price) {
      totalCents += parseInt(v.price) || 0;
      validCount++;
    }
  });

  // Costruisci sub-line dinamica
  // NC: usa _buildCartBtnHtml che produce '<s>orig</s> → discounted (-PCT%)'
  // RC: sub-line neutro placeholder (v2.6+ avrà calcolo live via Storefront API)
  var dc      = sessionStorage.getItem('skon_discount') || DISCOUNT_CONFIG.newCode;
  var isRC    = (dc === _getEffectiveRCDiscount().code);
  var btnHtml;
  if (totalCents > 0) {
    if (isRC) {
      // RC: NON uso _buildCartBtnHtml (produrrebbe 'primo X €, secondo Y €'
      // semanticamente errato per routine di 4 prodotti). Sub-line neutro.
      btnHtml = _t('ctaAddRoutine') + '<span class="cart-btn-sub">' + _t('ctaAddRoutineSubRC') + '</span>';
    } else {
      // NC: riuso _buildCartBtnHtml passando un finto "variant" con il totale
      btnHtml = _buildCartBtnHtml({ price: totalCents }, isRC, true);
      // Sovrascrivo il prefisso 'Aggiungi al carrello' con 'Aggiungi tutta la routine al carrello'
      btnHtml = btnHtml.replace(_t('btnAddToCart'), _t('ctaAddRoutine'));
    }
  } else {
    // Fallback safe: prezzi non disponibili → CTA senza sub-line
    btnHtml = _t('ctaAddRoutine');
  }

  var wrap = document.createElement('div');
  wrap.className = 'add-all-routine-wrap';
  // Bottone: stessa classe var-btn-primary del variant sheet per coerenza visiva.
  // id="btnAddRoutine" è cercato da addAllToCart() per il feedback testuale
  // ("Aggiungo…" → "Aggiunto al carrello!").
  // onclick passa SOLO 'core' (1 argomento): addAllToCart legge gli ID dei core
  // raccomandati da localStorage.skon_quiz_result.core (salvati al render result).
  wrap.innerHTML =
    '<button class="var-btn-primary add-all-routine-btn" '
      + 'id="btnAddRoutine" '
      + 'onclick="addAllToCart(\'core\')">'
    + btnHtml
    + '</button>';
  coreSection.appendChild(wrap);
}


/* ── restart ─────────────────────────────────────────────────────────── */
function addRestartButton() {
  var tipsSection = document.querySelector('.result-tips-section');
  if (!tipsSection) return;
  // Rimuove eventuali bottoni precedenti per evitare duplicati al rifacimento del test
  var existing = tipsSection.querySelector('.restart-wrap');
  if (existing) existing.parentNode.removeChild(existing);

  var div = document.createElement('div');
  div.className = 'restart-wrap';
  div.innerHTML =
    '<p class="restart-prompt">' + _t('restartPrompt') + '</p>'
    + '<button onclick="restartQuiz()" class="btn-restart">'
    + '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M1 4v6h6"/><path d="M3.51 15a9 9 0 102.13-9.36L1 10"/></svg>' + _t('restartBtn') + '</button>';
  tipsSection.appendChild(div);
}

function restartQuiz() {
  var savedAge   = S.answers.age;
  var savedEmail = S.userEmail || '';
  var savedName  = S.userName  || '';
  S.answers  = { age: savedAge, skin: null, desire: null, spf: null };
  S.userName = savedName;

  ['s-2','s-3','s-4'].forEach(function(sid) {
    var screen = document.getElementById(sid);
    if (screen) screen.querySelectorAll('.opt.selected').forEach(function(o) { o.classList.remove('selected'); });
  });
  ['b2','b3','b4'].forEach(function(bid) {
    var b = document.getElementById(bid);
    if (b) b.classList.add('off');
  });

  var emailIn    = document.getElementById('emailIn');
  var nameIn     = document.getElementById('nameIn');
  var privBox    = document.getElementById('privacyBox');
  var btnEmailEl = document.getElementById('btnEmail');

  // Pre-compila email e nome con i dati già inseriti in precedenza
  if (emailIn) emailIn.value = savedEmail;
  if (nameIn)  nameIn.value  = savedName;
  // Assicura che l'input nome e il toggle siano ripristinati correttamente
  // (il go('email') li gestirà, ma meglio resettare gli stili inline)
  var _niw = document.getElementById('nameInputWrap');
  var _net = document.getElementById('nameEditToggle');
  if (_niw) _niw.style.display = '';
  if (_net) _net.style.display = 'none';
  if (privBox) privBox.checked = false;

  // Ripristina il pulsante submit (rimuove disabled e "ATTENDERE..." e stili inline)
  if (btnEmailEl) {
    btnEmailEl.disabled           = false;
    btnEmailEl.textContent        = 'Ricevi il tuo protocollo';
    btnEmailEl.style.background   = '';
    btnEmailEl.style.color        = '';
    btnEmailEl.style.cursor       = '';
    btnEmailEl.style.boxShadow    = '';
    // Se email è già valida (pre-compilata) abilita il pulsante dopo il checkForm
    btnEmailEl.classList.remove('off');
    if (!savedEmail) btnEmailEl.classList.add('off');
  }

  // Aggiorna stato form (abilita/disabilita bottone in base all'email pre-compilata)
  if (typeof checkForm === 'function') setTimeout(checkForm, 50);

  // Nasconde la sticky bar — non ha senso durante il rifacimento del test
  var bar = document.getElementById('stickyDiscountBar');
  if (bar) {
    bar.style.transition = 'transform 300ms ease, opacity 300ms ease';
    bar.style.transform  = 'translateY(120%)';
    bar.style.opacity    = '0';
    setTimeout(function() {
      bar.style.display = 'none';
      bar.style.transform = '';
      bar.style.opacity   = '';
    }, 320);
  }
  // Ripristina il padding della pagina
  var shell = document.querySelector('.quiz-shell');
  if (shell) shell.style.paddingBottom = '';

  trackGA4('restart_quiz', {});
  S.step = 'result';
  window.scrollTo({ top: 0, behavior: 'smooth' });
  go(2);
}

/* ── updateDiscountUI() ──────────────────────────────────────────────── */
function updateDiscountUI(code) {
  if (!code) return;
  var isReturn = (code === _getEffectiveRCDiscount().code);
  // La UI principale è ora la sticky bar — questa funzione aggiorna solo le
  // componenti legacy del template (se presenti) per retro-compatibilità
  var codeEl   = document.getElementById('discountCode');
  var ctaSub   = document.querySelector('.result-cta-sub');
  var ctaTitle = document.querySelector('.result-cta-title');
  if (codeEl) codeEl.textContent = code;
  if (isReturn) {
    var firstName = (window.SKON_USER_NAME && window.SKON_USER_NAME.trim())
      ? ' ' + window.SKON_USER_NAME.trim().split(' ')[0].toUpperCase() : '';
    if (ctaTitle) ctaTitle.textContent = DISCOUNT_CONFIG.returnCtaTitle + firstName + '!';
    if (ctaSub) {
      var pct = Math.round(DISCOUNT_CONFIG.returnPct * 100);
      ctaSub.textContent = DISCOUNT_CONFIG.returnCtaSub.replace('{CODE}', code).replace('{PCT}', pct);
    }
  } else {
    if (ctaTitle) ctaTitle.textContent = DISCOUNT_CONFIG.newCtaTitle;
    if (ctaSub)   ctaSub.textContent   = DISCOUNT_CONFIG.newCtaSub;
  }
}

/* ── copyCode() ──────────────────────────────────────────────────────── */
function copyCode() {
  var codeEl = document.getElementById('discountCode');
  if (!codeEl) return;
  var code  = codeEl.textContent.trim();
  var toast = document.getElementById('copyToast');
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(code).then(function() {
      if (toast) { toast.textContent = 'Codice copiato!'; setTimeout(function() { toast.textContent = ''; }, 2500); }
    }).catch(function() { fallbackCopy(code, toast); });
  } else { fallbackCopy(code, toast); }
}
function fallbackCopy(text, toast) {
  var ta = document.createElement('textarea');
  ta.value = text; ta.style.cssText = 'position:fixed;top:-100px;opacity:0';
  document.body.appendChild(ta); ta.select();
  try { document.execCommand('copy'); if (toast) toast.textContent = 'Codice copiato!'; }
  catch(e) { if (toast) toast.textContent = 'Copia: ' + text; }
  document.body.removeChild(ta);
  setTimeout(function() { if (toast) toast.textContent = ''; }, 2500);
}

/* ══════════════════════════════════════════════════════════════════════
   INTEREST / VARIANT SHEET
   Aperto per TUTTI i prodotti (anche single-variant)
══════════════════════════════════════════════════════════════════════ */
function handleInterest(prodId, btn) {
  var resolvedId = resolveProduct(prodId);
  var prod = getCatalogProduct(resolvedId);
  if (!prod) return;

  var isNew = S.declaredInterests.indexOf(prodId) === -1 && S.declaredInterests.length < 3;
  if (isNew) {
    S.declaredInterests.push(prodId);
    updateDeclaredInterests();
  }

  trackGA4('interest_declared', {
    product_id:   prodId,
    slot_number:  S.declaredInterests.indexOf(prodId) + 1,
    section:      (btn && btn._prod) ? (btn._prod._section || 'core') : 'core',
  });
  if (typeof window.fbq === 'function') {
    window.fbq('track', 'AddToWishlist', {
      content_type: 'product', content_ids: [prodId],
      content_name: prod.name, currency: 'EUR',
      value: ((prod.shopVariants || [])[0] || {}).price / 100 || 0,
    });
  }

  var _sv = prod.shopVariants && prod.shopVariants.length > 0
    ? prod.shopVariants
    : [{ id: prod.variantId, title: 'Acquista', price: 0 }];
  openVariantSheet(Object.assign({}, prod, { _variants: _sv }), btn);
}

async function updateDeclaredInterests() {
  var email = S.userEmail;
  if (!email) return;
  var props = { quiz_self_declared_at: nowItalianTime() };
  S.declaredInterests.forEach(function(id, i) {
    props['quiz_self_declared_product_' + (i + 1)] = id;
  });
  try {
    await fetch('https://skon-quiz-check-magnews.admins-e7e.workers.dev/subscribe', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email:              email,
        properties:         props,
        isExistingCustomer: S.isReturningCustomer || false,
      })
    });
  } catch(e) { console.warn('[skon-quiz] declared interest update failed:', e.message); }
}

var _variantCache = {};
async function fetchVariants(handle) {
  if (_variantCache[handle]) return _variantCache[handle];
  try {
    var r = await fetch('/products/' + handle + '.js');
    if (!r.ok) return null;
    var data = await r.json();
    _variantCache[handle] = data.variants || [];
    return _variantCache[handle];
  } catch(e) { return null; }
}

function openVariantSheet(prod, btn) {
  var discountCode = sessionStorage.getItem('skon_discount') || DISCOUNT_CONFIG.newCode;
  var isRepeat     = (discountCode === _getEffectiveRCDiscount().code);
  var _sv          = prod._variants || prod.shopVariants || [];
  var isSingle     = _sv.length === 1;

  var overlay          = document.getElementById('varOverlay');
  var varList          = document.getElementById('varList');
  var varName          = document.getElementById('varName');
  var varSlug          = document.getElementById('varSlug');
  var varImg           = document.getElementById('varImg');
  var varSectionLabel  = overlay ? overlay.querySelector('.var-section-label') : null;
  if (!overlay || !varList) return;

  if (varName) varName.textContent = prod.name;
  if (varSlug) varSlug.textContent = prod.slug || '';
  if (varImg && prod.imgs && prod.imgs[0]) {
    varImg.src = prod.imgs[0]; varImg.alt = prod.name;
    varImg.style.display = '';
  } else if (varImg) {
    varImg.src = ''; varImg.style.display = 'none';
  }
  if (varSectionLabel) {
    varSectionLabel.textContent = _t('varSectionLabel');
    varSectionLabel.style.display = isSingle ? 'none' : '';
  }

  var variantsHtml = _sv.map(function(v) {
    var cents    = parseInt(v.price) || 0;
    var original = (cents/100).toFixed(2).replace('.', ',') + ' \u20ac';
    var priceHtml;
    if (isRepeat) {
      var rcPct = _getEffectiveRCDiscount().pct;
      var dr = ((cents*(1-rcPct))/100).toFixed(2).replace('.', ',') + ' \u20ac';
      priceHtml = '<span class="var-opt-price">' + original
        + '<span class="var-price-second-line">' + DISCOUNT_CONFIG.varPriceSecondLine + ' <strong>' + dr + '</strong></span></span>';
    } else {
      var np = getEffectiveNewDiscount().pct;
      var dn = ((cents*(1-np))/100).toFixed(2).replace('.', ',') + ' \u20ac';
      priceHtml = '<span class="var-opt-price"><s class="var-price-original">' + original
        + '</s><span class="var-price-discounted">' + dn + '</span></span>';
    }
    var imgHtmlV = '';
    if (prod.variantImgs && prod.variantImgs[v.id]) {
      var safeTitleV = v.title.replace(/'/g, "\\'");
      imgHtmlV = '<div class="var-opt-img-wrap" onclick="openTonalitaLightbox(' + v.id
        + ',\'' + safeTitleV + '\',\'' + (prod.id || '') + '\'); event.stopPropagation()">'
        + '<img class="var-opt-img" src="' + prod.variantImgs[v.id] + '" alt="' + v.title + '">'
        + '<span class="var-opt-zoom">&#128269;</span></div>';
    }
    return '<div class="var-opt' + (isSingle ? ' selected' : '') + (_sv.length > 4 ? ' var-opt--compact' : '')
      + '" data-vid="' + v.id + '" data-price="' + v.price + '" onclick="selectVariant(this)">'
      + imgHtmlV + '<span class="var-opt-name">' + v.title + '</span>' + priceHtml + '</div>';
  }).join('');

  var rp  = Math.round(_getEffectiveRCDiscount().pct * 100) + '%';
  var np2 = Math.round(getEffectiveNewDiscount().pct * 100) + '%';
  var discountNote;
  if (isRepeat) {
    discountNote = '<div class="var-discount-note var-discount-note--repeat">'
      + '<span class="var-discount-badge">' + _getEffectiveRCDiscount().code + '</span>'
      + '<span class="var-discount-text">Il secondo pezzo lo paghi al ' + rp + '.'
      + '<span class="var-checkout-note">' + DISCOUNT_CONFIG.returnBadgeNote + '</span></span></div>';
  } else {
    discountNote = '<div class="var-discount-note">'
      + '<span class="var-discount-badge">' + DISCOUNT_CONFIG.newBadgeLabel.replace('{PCT}', np2) + '</span>'
      + DISCOUNT_CONFIG.newBadgeNote + '</div>';
  }

  varList.innerHTML = variantsHtml + discountNote;

  var confirmBtn = document.getElementById('varConfirmBtn');
  if (confirmBtn) {
    if (isSingle && _sv[0]) {
      confirmBtn.classList.remove('off');
      confirmBtn.innerHTML = _buildCartBtnHtml(_sv[0], isRepeat, true);
    } else {
      confirmBtn.classList.add('off');
      confirmBtn.innerHTML = _t('btnAddToCart');
    }
  }

  overlay._skonProd = prod;
  overlay._skonBtn  = btn;

  var detailBtn = document.getElementById('varDetailBtn');
  if (detailBtn) {
    detailBtn.textContent = _t('btnViewProductSheet');
    detailBtn.onclick = function() { closeVariantSheet(); openDetailSheet(prod.id); };
  }

  overlay.classList.add('var-overlay--open');
  document.body.style.overflow = 'hidden';

  _attachSheetDragHandle(
    document.getElementById('varHandle'),
    document.querySelector('#varOverlay .var-sheet'),
    closeVariantSheet
  );
}

function selectVariant(el) {
  el.closest('.var-list').querySelectorAll('.var-opt').forEach(function(o) { o.classList.remove('selected'); });
  el.classList.add('selected');
  var confirmBtn = document.getElementById('varConfirmBtn');
  if (confirmBtn) {
    confirmBtn.classList.remove('off');
    var dc   = sessionStorage.getItem('skon_discount') || DISCOUNT_CONFIG.newCode;
    var isRC = (dc === _getEffectiveRCDiscount().code);
    var v    = { price: parseInt(el.dataset.price) || 0, title: '' }; // già in centesimi
    confirmBtn.innerHTML = _buildCartBtnHtml(v, isRC, true);
  }
}

function closeVariantSheet() {
  var overlay = document.getElementById('varOverlay');
  if (!overlay) return;
  overlay.classList.remove('var-overlay--open');
  document.body.style.overflow = '';
  // Reset stili inline dello sheet per la prossima apertura
  var sheet = overlay.querySelector('.var-sheet');
  if (sheet) {
    sheet.style.transition      = 'none';
    sheet.style.transform       = '';
    sheet.style.opacity         = '1';
    sheet.style.overflow        = '';
    sheet.style.transformOrigin = '';
  }
}

async function confirmVariant() {
  var overlay  = document.getElementById('varOverlay');
  if (!overlay) return;
  var selected = overlay.querySelector('.var-opt.selected');
  if (!selected) return;
  var variantId = parseInt(selected.dataset.vid);
  var prod      = overlay._skonProd;
  var origBtn   = overlay._skonBtn;
  closeVariantSheet();

  var btn = origBtn || { classList: { add: function(){}, remove: function(){} }, innerHTML: '' };
  btn.classList.add('adding');
  btn.innerHTML = 'Aggiungo\u2026';
  try {
    var cResp = await fetch('/cart/add.js', {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    });
    if (!cResp.ok) throw new Error('cart_add_failed');
    var dc = sessionStorage.getItem('skon_discount') || await getDiscountCode(S.userEmail||'');
    await applyDiscount(dc); updateDiscountUI(dc);
    _notifyCartUpdate();
    btn.classList.remove('adding'); btn.classList.add('added');
    btn.style.background = 'var(--orange)';
    btn.innerHTML = _t('cartAdded');
    trackGA4('add_to_cart_from_quiz', {
      product_id:        prod ? prod.id : '',
      variant_id:        variantId,
      source_section:    prod ? (prod._section || 'core') : 'core',
      is_routine_bundle: false,
    });
    setTimeout(function() {
      btn.classList.remove('added');
      btn.style.background = '';
      btn.innerHTML = _t('btnInterested');
    }, 6000);
  } catch(err) {
    btn.classList.remove('adding');
    btn.innerHTML = _t('btnInterested');
    console.warn('[skon-quiz] confirmVariant error:', err && err.message);
    // Non reindirizzare alla PDP — l'utente può usare "Vedi la pagina completa"
  }
}

/* Funzione generica drag handle per i bottom sheet */
/* ── Handle swipe-to-close — stessa logica della nc-experience ─────────
   Porta: haptic pill (grab/release), damped rubber-band, opacity fade,
   bounce-back con EASE_BACK, tutorial gesture alla prima apertura.
────────────────────────────────────────────────────────────────────── */
function _attachSheetDragHandle(handleEl, sheet, closeFn) {
  if (!handleEl || !sheet) return;

  var pill = handleEl.querySelector('.skon-sheet-handle-pill');

  var EASE       = 'cubic-bezier(0.16, 1, 0.3, 1)';
  var EASE_BACK  = 'cubic-bezier(0.34, 1.56, 0.64, 1)';
  var BAND_CLOSE = 30,  DAMP_CLOSE = 0.3;
  var BAND_OPEN  = 50,  DAMP_OPEN  = 0.18;
  var THRESHOLD  = 80,  SCALE_DAMP = 0.00015;
  var startY = 0, currentY = 0;

  function _translateY(raw) {
    if (raw > 0) {
      return raw <= BAND_CLOSE ? raw * DAMP_CLOSE : (BAND_CLOSE * DAMP_CLOSE) + (raw - BAND_CLOSE);
    } else {
      var a = Math.abs(raw);
      return -(a <= BAND_OPEN ? a * DAMP_OPEN : (BAND_OPEN * DAMP_OPEN) + (a - BAND_OPEN) * (DAMP_OPEN * 0.4));
    }
  }

  function _pillGrab() {
    if (!pill) return;
    pill.style.transition   = 'transform 120ms cubic-bezier(0.34,1.56,0.64,1), background 120ms';
    pill.style.transform    = 'scaleX(1.4) scaleY(0.55)';
    pill.style.background   = 'rgba(31,88,66,.6)';
    handleEl.style.transition = 'background 120ms cubic-bezier(0.34,1.56,0.64,1)';
    handleEl.style.background = 'rgba(31,88,66,.06)';
    // Vibrazione aptica al grab (Android/Chrome — no-op su iOS)
    if (navigator.vibrate) navigator.vibrate(15);
  }

  function _pillRelease() {
    if (!pill) return;
    pill.style.transition   = 'transform 200ms ' + EASE + ', background 200ms ' + EASE;
    pill.style.transform    = 'none';
    pill.style.background   = '';
    handleEl.style.transition = 'background 300ms ' + EASE;
    handleEl.style.background = '';
  }

  function _runGestureTutorial() {
    if (sessionStorage.getItem('skon_sheet_tutorial_done')) return;
    sessionStorage.setItem('skon_sheet_tutorial_done', '1');
    var hint = document.createElement('div');
    hint.style.cssText = 'position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);font-size:28px;pointer-events:none;opacity:0;will-change:transform,opacity;';
    hint.textContent = '☝️';
    handleEl.appendChild(hint);
    var ET = EASE;
    function _s(d, dur, tr, op) {
      setTimeout(function() {
        hint.style.transition = 'transform ' + dur + 'ms ' + ET + ', opacity ' + dur + 'ms ease';
        hint.style.transform  = tr;
        hint.style.opacity    = String(op);
      }, d);
    }
    function _on(d) { setTimeout(function() {
      if (!pill) return;
      pill.style.transition = 'transform 150ms cubic-bezier(0.34,1.56,0.64,1), background 150ms';
      pill.style.transform = 'scaleX(1.3) scaleY(0.6)'; pill.style.background = 'rgba(31,88,66,.6)';
      handleEl.style.transition = 'background 150ms cubic-bezier(0.34,1.56,0.64,1)';
      handleEl.style.background = 'rgba(31,88,66,.08)';
    }, d); }
    function _off(d) { setTimeout(function() {
      if (!pill) return;
      pill.style.transition = 'transform 300ms ' + ET + ', background 300ms ' + ET;
      pill.style.transform = 'none'; pill.style.background = '';
      handleEl.style.transition = 'background 300ms ' + ET; handleEl.style.background = '';
    }, d); }
    _s(0, 200, 'translate(-50%,-50%)', 0);
    _s(50, 250, 'translate(-50%,-50%)', 1);
    _on(400);  _s(400, 400, 'translate(-50%,calc(-50% + 14px))', 1); _off(820);  _s(850, 350, 'translate(-50%,-50%)', 1);
    _on(1300); _s(1300, 400, 'translate(-50%,calc(-50% + 14px))', 1); _off(1720); _s(1750, 350, 'translate(-50%,-50%)', 1);
    _s(2200, 300, 'translate(-50%,-50%)', 0);
    setTimeout(function() {
      if (hint.parentNode) hint.parentNode.removeChild(hint);
      handleEl.style.background = '';
      if (pill) { pill.style.background = ''; pill.style.transform = 'none'; }
    }, 2600);
  }

  handleEl.addEventListener('touchstart', function(e) {
    startY = currentY = e.touches[0].clientY;
    sheet.style.transition      = 'none';
    sheet.style.transformOrigin = 'center bottom';
    sheet.style.overflow        = 'hidden';
    _pillGrab();
  }, { passive: true });

  handleEl.addEventListener('touchmove', function(e) {
    currentY = e.touches[0].clientY;
    var raw      = currentY - startY;
    var progress = Math.min(1, Math.max(0, raw / 120));
    sheet.style.transform = 'translateY(' + _translateY(raw) + 'px)';
    sheet.style.opacity   = String(Math.max(0.15, 1 - progress * 1.5));
  }, { passive: true });

  handleEl.addEventListener('touchend', function() {
    _pillRelease();
    sheet.style.transformOrigin = '';
    sheet.style.overflow        = '';
    var raw = currentY - startY;
    sheet.style.opacity = '1';
    if (raw > THRESHOLD) {
      // Reset completo prima di chiudere — evita che valori residui
      // del drag vengano ereditati alla prossima apertura
      sheet.style.transition = 'none';
      sheet.style.transform  = '';
      sheet.style.opacity    = '1';
      sheet.style.overflow   = '';
      closeFn();
    } else {
      sheet.style.transition = 'transform 450ms ' + EASE_BACK + ', opacity 300ms ' + EASE;
      sheet.style.transform  = 'none';
    }
  }, { passive: true });

  /* Tutorial — 8s dopo apertura, solo prima volta */
  setTimeout(_runGestureTutorial, 8000);
}

/* ══════════════════════════════════════════════════════════════════════
   DETAIL SHEET — mini-PDP
══════════════════════════════════════════════════════════════════════ */
/* ══════════════════════════════════════════════════════════════════════
   DETAIL SHEET — mini-PDP completa
   - Gallery a scorrimento orizzontale (fino a 4 immagini)
   - Fetch /products/{handle}.js → descrizione "Cos'è?" dall'accordion
   - 3 livelli fallback per il testo descrizione
   - CTA varianti inline (sostituisce "Mi interessa" post-click)
   - Link PDP con sconto pre-applicato
══════════════════════════════════════════════════════════════════════ */
var _detailCache = {};
var _currentDetailProd = null;

function openDetailSheet(prodId) {
  var resolvedId = resolveProduct(prodId);
  var prod = getCatalogProduct(resolvedId);
  if (!prod) return;
  _currentDetailProd = prod;

  var overlay = document.getElementById('detailOverlay');
  if (!overlay) return;

  // Reset stato
  var detailContent = document.getElementById('detailContent');
  var detailLoading = document.getElementById('detailLoading');
  if (detailContent) detailContent.style.display = 'none';
  if (detailLoading) detailLoading.style.display  = 'flex';

  overlay.classList.add('detail-overlay--open');
  document.body.style.overflow = 'hidden';

  // Reset transform residuo da sessione precedente (drag o chiusura)
  var _detailSheet = document.querySelector('#detailOverlay .detail-sheet');
  if (_detailSheet) {
    _detailSheet.style.transition = 'none';
    _detailSheet.style.transform  = '';
    _detailSheet.style.opacity    = '1';
    _detailSheet.style.overflow   = '';
    void _detailSheet.offsetHeight; // forza reflow
  }
  var _detailInner = document.querySelector('#detailOverlay .detail-sheet-inner');
  if (_detailInner) _detailInner.scrollTop = 0;

  trackGA4('product_detail_view', { product_id: prodId });

  // Fetch prodotto Shopify (con cache)
  var dc = sessionStorage.getItem('skon_discount') || DISCOUNT_CONFIG.newCode;
  var pdpUrl = prod.url ? _addDiscountToUrl(prod.url, dc) : '#';

  if (_detailCache[prod.handle]) {
    _renderDetailSheet(prod, _detailCache[prod.handle], pdpUrl);
  } else if (prod.handle) {
    // Fetch HTML della pagina prodotto: contiene TUTTI gli accordion del tema
    // (metafield-based), non solo il body_html base del JSON .js
    fetch('/products/' + prod.handle)
      .then(function(r) { return r.ok ? r.text() : null; })
      .then(function(html) {
        var parsed = html ? _parseProductAccordions(html) : null;
        if (parsed) _detailCache[prod.handle] = parsed;
        _renderDetailSheet(prod, parsed, pdpUrl);
      })
      .catch(function() { _renderDetailSheet(prod, null, pdpUrl); });
  } else {
    _renderDetailSheet(prod, null, pdpUrl);
  }

  _attachSheetDragHandle(
    document.getElementById('detailHandle'),
    document.querySelector('#detailOverlay .detail-sheet'),
    closeDetailSheet
  );
}

/* Accordion labels cercati nella PDP Shopify */
/* Parsa gli accordion dalla pagina HTML del prodotto Shopify.
   Il tema Skön usa <details><summary>LABEL</summary>BODY</details>
   dentro il section accordion. Ritorna oggetto { description, accordions }
   compatibile con _renderDetailSheet. */
function _parseProductAccordions(html) {
  var parser = new DOMParser();
  var doc = parser.parseFromString(html, 'text/html');
  var allDetails = doc.querySelectorAll('details');
  var accordions = {};
  allDetails.forEach(function(det) {
    var sum = det.querySelector('summary');
    if (!sum) return;
    var labelRaw = (sum.textContent || '').trim();
    if (!labelRaw) return;
    // USA _accLabelKey — normalizzazione identica al lato match
    var key = _accLabelKey(labelRaw);
    if (!key) return;
    var clone = det.cloneNode(true);
    var cloneSum = clone.querySelector('summary');
    if (cloneSum) cloneSum.parentNode.removeChild(cloneSum);
    var body = clone.innerHTML.trim();
    if (body) accordions[key] = { label: labelRaw, body: body };
  });
  return { accordions: accordions, description: '' };
}

/* Mappa accordion: chiave normalizzata → label da mostrare come fallback.
   Il match usa uguaglianza esatta tra _accLabelKey(summary) e una delle aliases.
   INCI escluso intenzionalmente. */
var _ACC_SHOW = [
  { aliases: ['cose', "cos e", "cose "],       label: "Cos’è?" },
  { aliases: ['cosa fa', 'cosafa', 'cosefa'],   label: "Cosa fa?" },
  { aliases: ['texture'],                       label: "Texture" },
  { aliases: ['principi attivi','principiattivi','principi'], label: "Principi attivi" },
];

function _accLabelKey(label) {
  return label.toLowerCase()
    .replace(/[\u2019\u2018\u201a\u0060'"]/g, '') // tutti i tipi di apostrofo/virgoletta
    .replace(/[\u00e8\u00e9\u00ea]/g, 'e')        // è é ê → e
    .replace(/[\u00e0\u00e2]/g, 'a')              // à â → a
    .replace(/[\u00f2\u00f4]/g, 'o')              // ò ô → o
    .replace(/[?!.]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}

/* Collega listener 'toggle' agli accordion con animazione e gestione esclusiva */
function _bindAccordionExclusive(container) {
  if (!container) return;
  container.querySelectorAll('.detail-acc-item').forEach(function(det) {
    det.addEventListener('toggle', function() {
      var body = det.querySelector('.detail-acc-body');
      if (det.open) {
        // Apertura: anima con max-height da 0 a contenuto
        if (body) {
          body.style.maxHeight = '0';
          body.style.overflow  = 'hidden';
          body.style.opacity   = '0';
          body.style.transition = 'none';
          var natural = body.scrollHeight;
          requestAnimationFrame(function() {
            body.style.transition = 'max-height 280ms cubic-bezier(0.16,1,0.3,1), opacity 220ms ease';
            body.style.maxHeight  = natural + 'px';
            body.style.opacity    = '1';
            setTimeout(function() {
              body.style.maxHeight = '';
              body.style.overflow  = '';
            }, 300);
          });
        }
        // Chiude tutti gli altri
        container.querySelectorAll('.detail-acc-item').forEach(function(d) {
          if (d !== det && d.open) {
            var otherBody = d.querySelector('.detail-acc-body');
            if (otherBody) {
              var h = otherBody.scrollHeight;
              otherBody.style.maxHeight  = h + 'px';
              otherBody.style.overflow   = 'hidden';
              otherBody.style.transition = 'max-height 240ms cubic-bezier(0.16,1,0.3,1), opacity 180ms ease';
              requestAnimationFrame(function() {
                otherBody.style.maxHeight = '0';
                otherBody.style.opacity   = '0';
              });
            }
            setTimeout(function() { d.removeAttribute('open'); }, 250);
          }
        });
      } else {
        // Chiusura dell'elemento corrente
        if (body) {
          var h = body.scrollHeight;
          body.style.maxHeight  = h + 'px';
          body.style.overflow   = 'hidden';
          body.style.transition = 'max-height 240ms cubic-bezier(0.16,1,0.3,1), opacity 180ms ease';
          requestAnimationFrame(function() {
            body.style.maxHeight = '0';
            body.style.opacity   = '0';
          });
        }
      }
    });
  });
}
window._bindAccordionExclusive = _bindAccordionExclusive;

function _renderDetailSheet(prod, shopData, pdpUrl) {
  var detailContent   = document.getElementById('detailContent');
  var detailLoading   = document.getElementById('detailLoading');
  var detailName      = document.getElementById('detailName');
  var detailSlug      = document.getElementById('detailSlug');
  var detailAccordion = document.getElementById('detailAccordion');
  var detailActions   = document.getElementById('detailActions');

  if (detailName) detailName.textContent = prod.name;

  if (detailSlug) {
    detailSlug.innerHTML = (prod.slug || '')
      + (prod.tagline ? '<span class="detail-tagline-inline"> \u2014 ' + prod.tagline + '</span>' : '');
  }

  /* Gallery 1:1 scroll orizzontale */
  var galleryEl = document.getElementById('detailGallery');
  var imgs = (prod.imgs && prod.imgs.length > 0) ? prod.imgs : [];
  if (galleryEl) {
    if (imgs.length === 0) {
      galleryEl.innerHTML = '<div class="detail-img-placeholder"></div>';
    } else {
      var thumbs = imgs.map(function(src, i) {
        return '<div class="detail-gallery-item" data-idx="' + i + '" onclick="openGalleryLightbox(\'' + (prod.id) + '\',' + i + ')">'
          + '<img src="' + src + '" alt="' + prod.name + '" loading="lazy">'
          + '<span class="detail-gallery-zoom">&#128269;</span>'
          + '</div>';
      }).join('');
      var dots = imgs.length > 1 ? imgs.map(function(_, i) {
        return '<span class="detail-gallery-dot' + (i === 0 ? ' active' : '') + '" data-idx="' + i + '"></span>';
      }).join('') : '';
      galleryEl.innerHTML = '<div class="detail-gallery-scroll" id="detailGalleryScroll">' + thumbs + '</div>'
        + (dots ? '<div class="detail-gallery-dots">' + dots + '</div>' : '');
      var scroller = document.getElementById('detailGalleryScroll');
      if (scroller && imgs.length > 1) {
        scroller.addEventListener('scroll', function() {
          var w = scroller.offsetWidth || 1;
          var idx = Math.round(scroller.scrollLeft / w);
          galleryEl.querySelectorAll('.detail-gallery-dot').forEach(function(d, i) {
            d.classList.toggle('active', i === idx);
          });
        }, { passive: true });
        galleryEl.querySelectorAll('.detail-gallery-dot').forEach(function(d) {
          d.addEventListener('click', function() {
            var w = scroller.offsetWidth || 1;
            scroller.scrollTo({ left: parseInt(d.dataset.idx) * w, behavior: 'smooth' });
          });
        });
      }
    }
  }

  /* Accordion Cos'è / Cosa fa / Texture / Principi attivi */
  var sections = {};
  if (shopData) {
    /* Nuovo formato: { accordions: {key: {label, body}}, description } */
    if (shopData.accordions) {
      sections = shopData.accordions;
    } else {
      /* Compatibilità: vecchio formato JSON .js con description/body_html */
      var bodyHtml = shopData.description || shopData.body_html || '';
      if (bodyHtml) {
        var tempDiv = document.createElement('div');
        tempDiv.innerHTML = bodyHtml;
        var detEls = tempDiv.querySelectorAll('details');
        if (detEls.length > 0) {
          detEls.forEach(function(det) {
            var sum = det.querySelector('summary');
            if (!sum) return;
            var key   = _accLabelKey(sum.textContent || '');
            var label = (sum.textContent || '').trim();
            if (sum.parentNode) sum.parentNode.removeChild(sum);
            var body  = (det.innerHTML || '').trim();
            if (body) sections[key] = { label: label, body: body };
          });
        }
        if (!Object.keys(sections).length) {
          var paras = tempDiv.querySelectorAll('p');
          var allText = '';
          paras.forEach(function(p) {
            var t = (p.textContent || '').trim();
            if (t.length > 20) allText += '<p>' + t + '</p>';
          });
          if (allText) sections["cos\u2019\u00e8"] = { label: "Cos\u2019\u00e8?", body: allText };
        }
      }
    }
  }
  if (!Object.keys(sections).length && (prod.why || prod.tagline)) {
    sections["cos\u2019\u00e8"] = { label: "Cos\u2019\u00e8?", body: '<p>' + (prod.why || prod.tagline) + '</p>' };
  }

  var accordionHtml = '';
  var firstOpen = true;
  _ACC_SHOW.forEach(function(acc) {
    var found = null;
    // Match esatto: la chiave normalizzata della sezione deve essere uguale a una delle aliases
    Object.keys(sections).forEach(function(k) {
      if (found) return;
      if (acc.aliases.some(function(a) { return k === a; })) found = sections[k];
    });
    if (!found) return;
    var isOpen = firstOpen; firstOpen = false;
    accordionHtml +=
      '<details class="detail-acc-item"' + (isOpen ? ' open' : '') + '>'
      + '<summary class="detail-acc-title">' + found.label + '</summary>'
      + '<div class="detail-acc-body">' + found.body + '</div>'
      + '</details>';
  });
  if (!accordionHtml && Object.keys(sections).length) {
    var firstKey = Object.keys(sections)[0];
    accordionHtml = '<details class="detail-acc-item" open >'
      + '<summary class="detail-acc-title">' + sections[firstKey].label + '</summary>'
      + '<div class="detail-acc-body">' + sections[firstKey].body + '</div>'
      + '</details>';
  }
  if (detailAccordion) {
    detailAccordion.innerHTML = accordionHtml;
    _bindAccordionExclusive(detailAccordion);
  }

  if (detailActions) {
    detailActions.innerHTML =
      '<button class="var-btn-primary" id="detailInterestBtn" onclick="openDetailInlineVariants()">' + _t('btnInterested') + '</button>'
      + '<a class="var-btn-secondary" id="detailPdpLinkBtn" href="' + pdpUrl + '" target="_blank">' + _t('btnViewFullPage') + '</a>';
  }

  if (detailLoading) detailLoading.style.display = 'none';
  if (detailContent) detailContent.style.display  = 'block';
}

/* Lightbox tonalità AK — coverflow iTunes + add-to-cart */
var _akLightboxOpen = false;
var _akLightboxProd = null;
var _akLightboxVariantIds = [];
var _akLightboxIndex = 0;
var _akLbEl = null;

function _akLbRender(animate) {
  var lb = _akLbEl;
  if (!lb) return;
  var prod = _akLightboxProd;
  var ids  = _akLightboxVariantIds;
  var cur  = _akLightboxIndex;

  var vId      = ids[cur];
  var variant  = (prod.shopVariants || []).find(function(v) { return v.id == vId; });
  var fullTitle= variant ? variant.title : String(vId);
  var parts    = fullTitle.split(' ');
  var code     = parts[0] || '';
  var restName = parts.slice(1).join(' ');

  var dc   = sessionStorage.getItem('skon_discount') || '';
  var isRC = dc && typeof _getEffectiveRCDiscount === 'function' && dc === _getEffectiveRCDiscount().code;
  var cents = variant ? (parseInt(variant.price) || 0) : 0;
  var priceHtml = '';
  if (cents > 0) {
    if (isRC && typeof _getEffectiveRCDiscount === 'function') {
      var rcPct = _getEffectiveRCDiscount().pct;
      var dr    = ((cents * (1 - rcPct)) / 100).toFixed(2).replace('.', ',') + '\u00a0\u20ac';
      var orig  = (cents / 100).toFixed(2).replace('.', ',') + '\u00a0\u20ac';
      priceHtml = '<p class="ak-lb-price ak-lb-price--rc">' + orig + ' \u2014 <strong>il secondo ' + dr + '</strong></p>';
    } else if (typeof getEffectiveNewDiscount === 'function') {
      var np  = getEffectiveNewDiscount().pct;
      var dn  = ((cents * (1 - np)) / 100).toFixed(2).replace('.', ',') + '\u00a0\u20ac';
      var pct = Math.round(np * 100);
      priceHtml = '<p class="ak-lb-price"><s>' + (cents / 100).toFixed(2).replace('.', ',') + '\u00a0\u20ac</s> <strong>' + dn + '</strong> <span class="ak-lb-pct">-' + pct + '%</span></p>';
    }
  }

  var cap = lb.querySelector('.ak-lb-caption');
  if (cap) {
    cap.innerHTML = ''
      + '<div class="ak-lb-dots">' + ids.map(function(_, i) {
          return '<span class="ak-lb-dot' + (i === cur ? ' active' : '') + '"></span>';
        }).join('') + '</div>'
      + '<strong class="ak-lb-title">' + prod.name + ' — ' + code + '</strong>'
      + (restName ? '<span class="ak-lb-sub">' + restName + '</span>' : '')
      + priceHtml
      + '<button class="ak-lb-atc" onclick="akLbAddToCart(' + vId + ')">' + _t('btnAddVariantToCart', { code: code }) + '</button>'
      + '<p class="ak-lb-reassure">Non temere di sbagliare tonalit\u00e0 \u2014 hai 30 giorni per cambiare il prodotto!</p>';
  }

  /* Coverflow: ogni slide posizionata con rotateY e scale */
  var track = lb.querySelector('.ak-lb-track');
  if (!track) return;
  var items = track.querySelectorAll('.ak-lb-slide');
  var dur = animate ? '360ms' : '0ms';
  items.forEach(function(slide, i) {
    var rel = i - cur;
    var abs = Math.abs(rel);
    var tx  = rel * 62;       /* traslazione % */
    var ry  = -rel * 44;      /* rotazione prospettica */
    var sc  = abs === 0 ? 1 : (abs === 1 ? 0.70 : 0.50);
    var op  = abs === 0 ? 1 : (abs === 1 ? 0.50 : 0.20);
    var zi  = 10 - abs;
    slide.style.transition    = 'transform ' + dur + ' cubic-bezier(0.25,0.46,0.45,0.94), opacity ' + dur;
    slide.style.transform     = 'translateX(' + tx + '%) rotateY(' + ry + 'deg) scale(' + sc + ')';
    slide.style.opacity       = op;
    slide.style.zIndex        = zi;
    slide.style.pointerEvents = abs === 0 ? 'auto' : 'none';
  });
}
window._akLbRender = _akLbRender;

function akLbGoTo(idx) {
  var n = _akLightboxVariantIds.length;
  _akLightboxIndex = ((idx % n) + n) % n;
  _akLbRender(true);
}
window.akLbGoTo = akLbGoTo;

function akLbAddToCart(variantId) {
  var btn = _akLbEl && _akLbEl.querySelector('.ak-lb-atc');
  if (btn) { btn.disabled = true; btn.textContent = _t('cartAddedShort'); btn.style.background = 'rgba(31,88,66,.8)'; }
  var dc = sessionStorage.getItem('skon_discount') || '';
  var body = { items: [{ id: variantId, quantity: 1 }] };
  if (dc) body.attributes = { discount_code: dc };
  fetch('/cart/add.js', {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  }).then(function() { if (dc) return fetch('/discount/' + dc); }).catch(function(){});
}
window.akLbAddToCart = akLbAddToCart;

function openTonalitaLightbox(variantId, variantTitle, prodId) {
  if (_akLightboxOpen) return;
  var prod = getCatalogProduct(prodId);
  if (!prod || !prod.variantImgs) return;
  _akLightboxOpen       = true;
  _akLightboxProd       = prod;
  _akLightboxVariantIds = Object.keys(prod.variantImgs).map(Number);
  _akLightboxIndex      = Math.max(0, _akLightboxVariantIds.indexOf(Number(variantId)));

  var slides = _akLightboxVariantIds.map(function(vId, i) {
    return '<div class="ak-lb-slide" data-idx="' + i + '"><img class="ak-lb-img" src="' + prod.variantImgs[vId] + '" alt="" draggable="false"></div>';
  }).join('');

  var lb = document.createElement('div');
  lb.id = 'akTonalitaLightbox';
  lb.className = 'ak-lb-overlay';
  lb.innerHTML =
    '<div class="ak-lb-inner" onclick="event.stopPropagation()">'
    + '<button class="ak-lb-close" onclick="closeTonalitaLightbox()">'
    + '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>'
    + '</button>'
    + '<div class="ak-lb-stage"><div class="ak-lb-track">' + slides + '</div></div>'
    + '<div class="ak-lb-caption"></div>'
    + '</div>';

  _akLbEl = lb;

  var touchStartX = 0;
  lb.addEventListener('touchstart', function(e) { touchStartX = e.touches[0].clientX; }, { passive: true });
  lb.addEventListener('touchend', function(e) {
    var dx = e.changedTouches[0].clientX - touchStartX;
    var dy = e.changedTouches[0].clientY - e.touches[0]?.clientY || 0;
    if (Math.abs(dx) > 36) akLbGoTo(_akLightboxIndex + (dx < 0 ? 1 : -1));
  }, { passive: true });
  lb.addEventListener('click', function(e) { if (e.target === lb) closeTonalitaLightbox(); });

  document.body.appendChild(lb);
  document.body.style.overflow = 'hidden';
  requestAnimationFrame(function() {
    lb.classList.add('ak-lb-visible');

    // Intro: parte da target-3, scorre fino alla variante toccata
    var target   = _akLightboxIndex;
    var n        = _akLightboxVariantIds.length;
    var startIdx = ((target - 3) % n + n) % n;
    _akLightboxIndex = startIdx;
    _akLbRender(false);

    // Sequenza indici startIdx → target (in avanti)
    var steps = [];
    var cur = startIdx;
    while (cur !== target) { cur = (cur + 1) % n; steps.push(cur); }

    // Intervalli decrescenti: rallenta sull'arrivo
    var intervals = [300, 220, 160];
    var elapsed = 180;
    steps.forEach(function(stepIdx, i) {
      elapsed += (intervals[i] !== undefined ? intervals[i] : 140);
      setTimeout(function() { _akLightboxIndex = stepIdx; _akLbRender(true); }, elapsed);
    });
  });
}
window.openTonalitaLightbox = openTonalitaLightbox;

function closeTonalitaLightbox() {
  var lb = document.getElementById('akTonalitaLightbox');
  if (!lb) return;
  lb.classList.remove('ak-lb-visible');
  _akLightboxOpen = false; _akLightboxProd = null; _akLbEl = null;
  document.body.style.overflow = '';
  setTimeout(function() { if (lb.parentNode) lb.parentNode.removeChild(lb); }, 280);
}
window.closeTonalitaLightbox = closeTonalitaLightbox;
/* "Mi interessa" nel detail-sheet → chiude e apre il variation-sheet */
function openDetailInlineVariants() {
  var prod = _currentDetailProd;
  if (!prod) return;
  closeDetailSheet();
  setTimeout(function() {
    openVariantSheet(prod); // passa l'oggetto prod, non prod.id
  }, 120);
}

function selectDetailVariant(el) {
  el.closest('.var-list').querySelectorAll('.var-opt').forEach(function(o) { o.classList.remove('selected'); });
  el.classList.add('selected');
  var btn = document.getElementById('detailInlineCartBtn');
  if (btn) { btn.classList.remove('off'); _updateDetailCartBtnText(); }
}

function _updateDetailCartBtnText() {
  var btn      = document.getElementById('detailInlineCartBtn');
  var listEl   = document.getElementById('detailInlineVarList');
  if (!btn || !listEl) return;
  var selected = listEl.querySelector('.var-opt.selected');
  if (!selected) return;

  var dc   = sessionStorage.getItem('skon_discount') || DISCOUNT_CONFIG.newCode;
  var isRC = (dc === _getEffectiveRCDiscount().code);
  var v    = { price: parseInt(selected.dataset.price) || 0, title: '' }; // già in centesimi
  btn.innerHTML = _buildCartBtnHtml(v, isRC, true);
}

/* Costruisce HTML del testo nel pulsante add-to-cart con prezzi */
function _buildCartBtnHtml(variant, isRC, hasSelection) {
  if (!hasSelection) return _t('btnAddToCart');
  var cents = parseInt(variant.price) || 0;
  if (cents === 0) return _t('btnAddToCart');

  var originalStr = (cents / 100).toFixed(2).replace('.', ',') + '\u00a0\u20ac';
  var subLine;

  if (isRC) {
    var rcPct  = _getEffectiveRCDiscount().pct;
    var price1 = (cents / 100).toFixed(2).replace('.', ',');
    var price2 = ((cents * (1 - rcPct)) / 100).toFixed(2).replace('.', ',');
    subLine = 'il primo lo paghi ' + price1 + '\u00a0\u20ac, il secondo solo ' + price2 + '\u00a0\u20ac';
  } else {
    var np      = getEffectiveNewDiscount().pct;
    var discounted = ((cents * (1 - np)) / 100).toFixed(2).replace('.', ',');
    var pctDisp = Math.round(np * 100);
    subLine = '<s>' + originalStr + '</s> \u2192 ' + discounted + '\u00a0\u20ac (-' + pctDisp + '%)';
  }
  return _t('btnAddToCart') + '<span class="cart-btn-sub">' + subLine + '</span>';
}

async function addDetailInlineToCart() {
  var listEl = document.getElementById('detailInlineVarList');
  var btn    = document.getElementById('detailInlineCartBtn');
  if (!listEl || !btn) return;
  var selected = listEl.querySelector('.var-opt.selected');
  if (!selected) return;
  var variantId = parseInt(selected.dataset.vid);
  if (!variantId) return;

  btn.disabled = true;
  btn.innerHTML = 'Aggiungo\u2026';
  btn.style.background = 'var(--orange)';

  try {
    var r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    });
    if (!r.ok) throw new Error('cart_add_failed');
    var dc = sessionStorage.getItem('skon_discount') || DISCOUNT_CONFIG.newCode;
    await applyDiscount(dc);
    _notifyCartUpdate();
    btn.innerHTML = _t('cartAdded');

    trackGA4('add_to_cart_from_quiz', {
      product_id: _currentDetailProd ? _currentDetailProd.id : '',
      variant_id: variantId,
      source_section: 'detail_sheet',
      is_routine_bundle: false,
    });

    setTimeout(function() {
      btn.disabled = false;
      btn.style.background = '';
      btn.innerHTML = _t('btnAddToCart');
    }, 6000);
  } catch(err) {
    btn.disabled = false;
    btn.style.background = '';
    btn.innerHTML = _t('btnAddToCart');
    console.warn('[skon-quiz] addDetailInlineToCart error:', err && err.message);
    // Non reindirizzare alla PDP — l'utente può usare "Vedi la pagina completa"
  }
}

function closeDetailSheet() {
  var overlay = document.getElementById('detailOverlay');
  if (!overlay) return;
  overlay.classList.remove('detail-overlay--open');
  document.body.style.overflow = '';
  _currentDetailProd = null;
  // Reset immediato — prima che qualsiasi altra apertura possa avvenire
  var _sheet = overlay.querySelector('.detail-sheet');
  if (_sheet) {
    _sheet.style.transition      = 'none';
    _sheet.style.transform       = '';
    _sheet.style.opacity         = '1';
    _sheet.style.overflow        = '';
    _sheet.style.transformOrigin = '';
  }
  setTimeout(function() {
    // Reset transform/opacity (difesa aggiuntiva dopo la transizione di chiusura)
    var sheet = document.querySelector('#detailOverlay .detail-sheet');
    if (sheet) {
      sheet.style.transition = 'none';
      sheet.style.transform  = '';
      sheet.style.opacity    = '1';
      sheet.style.overflow   = '';
    }
    // Ripristina tutti gli elementi nascosti da openDetailInlineVariants
    ['detailGallery','detailName','detailSlug','detailAccordion'].forEach(function(id) {
      var el = document.getElementById(id);
      if (el) { el.style.display = ''; el.innerHTML = ''; el.style.cssText = ''; }
    });
    var act = document.getElementById('detailActions');
    if (act) { act.innerHTML = ''; act.style.animation = ''; }
    // Reset scroll
    var inner = document.querySelector('#detailOverlay .detail-sheet-inner');
    if (inner) inner.scrollTop = 0;
  }, 350);
}

function openDetailFromVariantSheet() {
  var overlay = document.getElementById('varOverlay');
  if (!overlay || !overlay._skonProd) return;
  var prod = overlay._skonProd;
  closeVariantSheet();
  openDetailSheet(prod.id);
}

function openDetailVariantSheet() {
  if (!_currentDetailProd) return;
  openDetailInlineVariants();
}

/* ══════════════════════════════════════════════════════════════════════
   CART / DISCOUNT / CHECKOUT
══════════════════════════════════════════════════════════════════════ */
async function getDiscountCode(email) {
  if (window.SKON_CUSTOMER && window.SKON_CUSTOMER.loggedIn) {
    return window.SKON_CUSTOMER.ordersCount > 0 ? _getEffectiveRCDiscount().code : getEffectiveNewDiscount().code;
  }
  try {
    var res = await fetch('https://skon-quiz-check-magnews.admins-e7e.workers.dev/check-customer', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email }),
      signal: AbortSignal.timeout(4000),
    });
    if (res.ok) {
      var data = await res.json();
      return data.isCustomer ? _getEffectiveRCDiscount().code : getEffectiveNewDiscount().code;
    }
  } catch(err) { console.warn('[skon-quiz] worker non raggiungibile:', err.message); }
  return getEffectiveNewDiscount().code;
}

/* ── Applica codice sconto a TUTTI i link della pagina risultati ─────── */
var CATALOG_BASE_URL = 'https://skoncosmetics.com';

function _addDiscountToUrl(url, code) {
  if (!code || !url) return url;
  try {
    var u = new URL(url, CATALOG_BASE_URL);
    u.searchParams.set('discount', code);
    return u.toString();
  } catch(e) { return url; }
}

function _patchAllResultLinks(code) {
  if (!code) return;
  // Tutti gli <a> con href che puntano a skoncosmetics.com/products/* o /collections/*
  var links = document.querySelectorAll('#s-result a[href], .detail-sheet a[href], .var-sheet a[href]');
  links.forEach(function(a) {
    var href = a.getAttribute('href');
    if (!href) return;
    if (href.indexOf('skoncosmetics.com') !== -1 || href.startsWith('/products') || href.startsWith('/collections')) {
      a.setAttribute('href', _addDiscountToUrl(href, code));
    }
  });
  // CTA catalogo nella sticky bar
  var catalogCta = document.getElementById('stickyCatalogCta');
  if (catalogCta) {
    catalogCta.href = 'https://skoncosmetics.com/collections/catalogo?discount=' + code;
  }
}

/* ── Aggiornamento applyDiscount: patcha i link post-applicazione ─────── */
async function applyDiscount(code) {
  if (!code) return;
  try { sessionStorage.setItem('skon_discount', code); } catch(e) {}
  _patchAllResultLinks(code);
  try { await fetch('/discount/' + code, { credentials: 'include' }); } catch(e) {}
}

async function addToCart(handle, variantId, btn) {
  if (!handle && !variantId) return;
  if (btn._prod) { openVariantSheet(btn._prod, btn); return; }
  btn.classList.add('adding');
  btn.innerHTML = 'Aggiungo\u2026';
  try {
    if (!variantId) throw new Error('no_variant');
    var cResp = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    });
    if (!cResp.ok) throw new Error('cart_add_failed');
    var storedCode   = sessionStorage.getItem('skon_discount');
    var discountCode = storedCode || await getDiscountCode(S.userEmail || '');
    await applyDiscount(discountCode); updateDiscountUI(discountCode);
    btn.classList.remove('adding'); btn.classList.add('added'); _notifyCartUpdate();
    btn.innerHTML = _t('cartAdded');
    setTimeout(function() { btn.classList.remove('added'); btn.innerHTML = _t('btnInterested'); }, 3000);
  } catch(err) {
    btn.classList.remove('adding');
    btn.innerHTML = _t('btnInterested');
    console.warn('[skon-quiz] addToCart error:', err && err.message);
    // Non reindirizzare alla PDP — evita navigazioni indesiderate
  }
}

async function refreshCartCount() {
  try {
    var r = await fetch('/cart.js', { credentials: 'include' });
    if (!r.ok) return;
    var cart   = await r.json();
    var count  = cart.item_count || 0;
    var cartLink = document.getElementById('headerCart');
    var badge    = document.getElementById('cartCount');
    if (!cartLink) return;
    if (count > 0) {
      cartLink.style.display = ''; // rimuove eventuale display:none inline
      cartLink.classList.add('visible');
      if (badge) { badge.style.display = ''; badge.textContent = count; }
    } else {
      cartLink.classList.remove('visible');
    }
  } catch(e) {}
}

/* ══════════════════════════════════════════════════════════════════════
   _bindHeaderCart() — Apertura side-cart del tema tramite click su #headerCart
   ──────────────────────────────────────────────────────────────────────
   Intercetta il click sull'icona carrello in alto a destra e chiama
   programmaticamente cart-drawer-component.open() del tema (Online Store 2.0).

   Approccio robusto (non declarative): non dipende da on:click="/open"
   gestito dal tema in fase di hydration. Funziona anche se l'inizializzazione
   dei custom elements del tema arriva dopo il bootstrap del quiz.

   Fallback safe: se cart-drawer-component non è nel DOM (es. {% render %}
   nel Liquid è stato rimosso), log warning e redirect a /cart standard.
══════════════════════════════════════════════════════════════════════ */
function _bindHeaderCart() {
  var btn = document.getElementById('headerCart');
  if (!btn) return;
  // Evita doppio bind in caso di re-init
  if (btn.dataset.skonCartBound === '1') return;
  btn.dataset.skonCartBound = '1';

  btn.addEventListener('click', function(e) {
    e.preventDefault();
    var drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') {
      try {
        drawer.open();
      } catch(err) {
        console.warn('[skon-quiz] cart-drawer.open() ha fallito:', err && err.message);
        window.location.href = '/cart';
      }
    } else {
      console.warn('[skon-quiz] cart-drawer-component non disponibile nel DOM, redirect a /cart');
      window.location.href = '/cart';
    }
  });
}

/* Notifica il tema dopo ogni add-to-cart — refresh badge cart count
   e dispatch 'cart:refresh' su document per eventuali listener (es.
   cart-drawer-component lo ignora finché non riceve CartAddEvent). */
function _notifyCartUpdate() {
  refreshCartCount();
  // Dispatch 'cart:update' (ThemeEvents.cartUpdate) per triggerare il
  // refresh del cart-items-component del tema (sezione cart-drawer-host).
  // Senza questo dispatch, il drawer renderizzato lato Liquid al page load
  // resta congelato con i prodotti del cart al momento della richiesta.
  // bubbles: true è necessario perché il listener è su document.
  try {
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: {},
        sourceId: 'skon-quiz',
        data: {} // no sections → il componente fa refetch da solo
      }
    }));
  } catch(e) { /* CustomEvent non supportato — ignore */ }
}


/* ── Animazione intro sconto: emoji regalo che vola verso la sticky bar ─── */
function _showDiscountIntro() {
  if (sessionStorage.getItem('skon_discount_intro_done')) return;
  var bar = document.getElementById('stickyDiscountBar');
  if (!bar || bar.style.display === 'none') return;
  sessionStorage.setItem('skon_discount_intro_done', '1');

  // ── Overlay ───────────────────────────────────────────────────────────────
  var overlay = document.createElement('div');
  overlay.id = 'discountIntroOverlay';
  overlay.style.cssText = 'position:fixed;inset:0;z-index:8000;background:rgba(0,0,0,0);pointer-events:none;transition:background 200ms ease;';
  document.body.appendChild(overlay);

  var header = document.querySelector('.quiz-header');
  var prevHeaderZ = header ? header.style.zIndex : '';
  var prevBarZ = bar.style.zIndex;
  if (header) header.style.zIndex = '8100';
  bar.style.zIndex = '8100';

  // ── Emoji ─────────────────────────────────────────────────────────────────
  var emoji = document.createElement('div');
  emoji.textContent = '\uD83C\uDF81';
  emoji.style.cssText = [
    'position:fixed', 'z-index:8200',
    'font-size:110px', 'line-height:1',
    'top:50%', 'left:50%',
    'transform:translate(-50%,-50%) scale(0)',
    'pointer-events:none',
    'will-change:transform,opacity',
    'filter:drop-shadow(0 10px 32px rgba(0,0,0,.30))',
    'transform-origin:center center',
  ].join(';');
  document.body.appendChild(emoji);

  // ── FASE 1: fade overlay + bounce pop (0–450ms) ───────────────────────────
  requestAnimationFrame(function() {
    overlay.style.background = 'rgba(0,0,0,0.50)';
    requestAnimationFrame(function() {
      emoji.style.transition = 'transform 260ms cubic-bezier(0.34,1.56,0.64,1)';
      emoji.style.transform  = 'translate(-50%,-50%) scale(1.28)';
    });
  });
  setTimeout(function() {
    emoji.style.transition = 'transform 140ms cubic-bezier(0.25,0,0.5,1)';
    emoji.style.transform  = 'translate(-50%,-50%) scale(0.92)';
  }, 270);
  setTimeout(function() {
    emoji.style.transition = 'transform 110ms ease-out';
    emoji.style.transform  = 'translate(-50%,-50%) scale(1)';
  }, 410);

  // ── FASE 2: pausa leggibile (450–1050ms) ──────────────────────────────────
  // nessun codice — emoji ferma a centro

  // ── FASE 3: volo a spirale verso la bar (1050–1530ms) ─────────────────────
  setTimeout(function() {
    // Coordinate assolute del centro del viewport
    var vw = window.innerWidth;
    var vh = window.innerHeight;
    var startX = vw / 2;
    var startY = vh / 2;

    // Coordinate assolute del target: emoji 🎁 nella collapsed label della bar
    // La bar è `position:fixed; bottom:0` — la label è dentro di essa
    var barRect   = bar.getBoundingClientRect();
    // L'emoji 🎁 è nel testo della collapsed label, circa al 20% da sinistra
    var targetAbsX = barRect.left + barRect.width * 0.20;
    var targetAbsY = barRect.top  + barRect.height * 0.50;

    // Delta rispetto al centro (punto di partenza dell'emoji)
    var dx = targetAbsX - startX;
    var dy = targetAbsY - startY;

    // Punto intermedio per simulare curva a spirale aurea:
    // Prima si sposta verso l'alto-destra (arco ampio),
    // poi curva in basso verso la bar (arco stretto)
    // Il punto intermedio è a ~55% del percorso orizzontale e -35% verticale
    var midAbsX = startX + dx * 0.55 + Math.abs(dy) * 0.30;
    var midAbsY = startY + dy * 0.20 - Math.abs(dx) * 0.18;
    var midDx = midAbsX - startX;
    var midDy = midAbsY - startY;

    // Segmento 1: verso il punto intermedio (250ms)
    emoji.style.transition = [
      'transform 250ms cubic-bezier(0.20,0,0.80,1)',
      'font-size 250ms ease',
    ].join(',');
    emoji.style.fontSize  = '55px';
    emoji.style.transform = 'translate(calc(-50% + ' + Math.round(midDx) + 'px), calc(-50% + ' + Math.round(midDy) + 'px)) scale(0.80) rotate(210deg)';
  }, 1050);

  // Segmento 2: dal punto intermedio alla bar (280ms, accelera e sparisce)
  setTimeout(function() {
    var vw = window.innerWidth;
    var vh = window.innerHeight;
    var barRect   = bar.getBoundingClientRect();
    var targetAbsX = barRect.left + barRect.width * 0.20;
    var targetAbsY = barRect.top  + barRect.height * 0.50;
    var dx = targetAbsX - vw / 2;
    var dy = targetAbsY - vh / 2;

    emoji.style.transition = [
      'transform 280ms cubic-bezier(0.55,0,1,0.9)',
      'opacity 180ms ease 100ms',
      'font-size 280ms ease',
    ].join(',');
    emoji.style.fontSize  = '14px';
    emoji.style.opacity   = '0';
    // Arrivo ESATTAMENTE sul target
    emoji.style.transform = 'translate(calc(-50% + ' + Math.round(dx) + 'px), calc(-50% + ' + Math.round(dy) + 'px)) scale(0.10) rotate(570deg)';
  }, 1305);

  // ── FASE 4: sussulto della bar all'arrivo (1530ms) ─────────────────────────
  setTimeout(function() {
    if (navigator.vibrate) navigator.vibrate(15);
    bar.style.transition = 'transform 90ms ease-out';
    bar.style.transform  = 'translateY(-10px)';
  }, 1530);
  setTimeout(function() {
    bar.style.transition = 'transform 130ms cubic-bezier(0.34,1.56,0.64,1)';
    bar.style.transform  = 'translateY(4px)';
  }, 1620);
  setTimeout(function() {
    bar.style.transition = 'transform 110ms ease-out';
    bar.style.transform  = 'translateY(0)';
  }, 1750);

  // ── FASE 5: fade-out overlay DOPO il bounce (1900ms) ──────────────────────
  setTimeout(function() {
    overlay.style.transition = 'background 280ms ease';
    overlay.style.background = 'rgba(0,0,0,0)';
    setTimeout(function() {
      if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
      if (emoji.parentNode)   emoji.parentNode.removeChild(emoji);
      if (header) header.style.zIndex = prevHeaderZ;
      bar.style.zIndex = prevBarZ;
    }, 290);
  }, 1900);
}




function copyStickyCode() {
  var codeEl = document.getElementById('stickyCodeValue');
  var code = codeEl ? codeEl.textContent.trim() : '';
  if (!code) return;
  var labelEl = document.getElementById('stickyCopyLabel');
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(code).then(function() {
      if (labelEl) { labelEl.textContent = 'Copiato!'; setTimeout(function() { labelEl.textContent = 'Copia'; }, 2000); }
    }).catch(function() { _fallbackCopyStickyCode(code, labelEl); });
  } else { _fallbackCopyStickyCode(code, labelEl); }
}
function _fallbackCopyStickyCode(text, labelEl) {
  var ta = document.createElement('textarea');
  ta.value = text; ta.style.cssText = 'position:fixed;top:-100px;opacity:0';
  document.body.appendChild(ta); ta.select();
  try { document.execCommand('copy'); if (labelEl) labelEl.textContent = 'Copiato!'; }
  catch(e) {}
  document.body.removeChild(ta);
  setTimeout(function() { if (labelEl) labelEl.textContent = 'Copia'; }, 2000);
}


/* Tutorial gesture sulla sticky bar — stessa logica degli sheet prodotto */
function _runStickyTutorial() {
  if (sessionStorage.getItem('skon_sticky_tutorial_done')) return;
  sessionStorage.setItem('skon_sticky_tutorial_done', '1');

  var handle = document.getElementById('stickyDiscountHandle');
  var bar    = document.getElementById('stickyDiscountBar');
  if (!handle || !bar) return;

  var pill = handle.querySelector('.sticky-pill');
  var EASE = 'cubic-bezier(0.16, 1, 0.3, 1)';

  // Hint emoji manina
  var hint = document.createElement('div');
  hint.style.cssText = 'position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);font-size:28px;pointer-events:none;opacity:0;will-change:transform,opacity;z-index:10;';
  hint.textContent = '☝️';
  handle.style.position = 'relative';
  handle.appendChild(hint);

  function _s(delay, dur, tr, op) {
    setTimeout(function() {
      hint.style.transition = 'transform ' + dur + 'ms ' + EASE + ', opacity ' + dur + 'ms ease';
      hint.style.transform  = tr;
      hint.style.opacity    = String(op);
    }, delay);
  }
  function _pillOn(delay) {
    setTimeout(function() {
      if (!pill) return;
      pill.style.transition = 'transform 150ms cubic-bezier(0.34,1.56,0.64,1), background 150ms';
      pill.style.transform  = 'scaleX(1.3) scaleY(0.6)';
      pill.style.background = 'rgba(255,255,255,.70)';
      handle.style.transition = 'background 150ms cubic-bezier(0.34,1.56,0.64,1)';
      handle.style.background = 'rgba(255,255,255,.15)';
    }, delay);
  }
  function _pillOff(delay) {
    setTimeout(function() {
      if (!pill) return;
      pill.style.transition = 'transform 300ms ' + EASE + ', background 300ms ' + EASE;
      pill.style.transform  = 'none';
      pill.style.background = '';
      handle.style.transition = 'background 300ms ' + EASE;
      handle.style.background = '';
    }, delay);
  }

  // Sequenza identica a _runGestureTutorial:
  // appare → scende (simula trascinamento verso il basso = chiude la bar) → sale → ripete
  _s(0,   200, 'translate(-50%,-50%)', 0);
  _s(50,  250, 'translate(-50%,-50%)', 1);
  _pillOn(400);
  _s(400, 400, 'translate(-50%,calc(-50% + 14px))', 1);
  _pillOff(820);
  _s(850, 350, 'translate(-50%,-50%)', 1);

  _pillOn(1300);
  _s(1300, 400, 'translate(-50%,calc(-50% + 14px))', 1);
  _pillOff(1720);
  _s(1750, 350, 'translate(-50%,-50%)', 1);

  _s(2200, 300, 'translate(-50%,-50%)', 0);
  setTimeout(function() {
    if (hint.parentNode) hint.parentNode.removeChild(hint);
    handle.style.background = '';
    if (pill) { pill.style.background = ''; pill.style.transform = 'none'; }
  }, 2600);
}


function _toggleNameField() {
  var wrap   = document.getElementById('nameInputWrap');
  var toggle = document.getElementById('nameEditToggle');
  var nameIn = document.getElementById('nameIn');
  if (!wrap) return;
  var isHidden = wrap.style.display === 'none';
  wrap.style.display = isHidden ? '' : 'none';
  if (toggle) toggle.style.display = isHidden ? 'none' : 'inline-flex';
  if (isHidden && nameIn) {
    nameIn.focus();
    // Sposta il cursore alla fine del testo esistente
    var v = nameIn.value;
    nameIn.value = '';
    nameIn.value = v;
  }
}


/* ── Esposizione globale ─────────────────────────────────────────────── */
// Funzioni chiamate direttamente dall'HTML (onclick, onblur, oninput)
window.go                         = go;
window.pick                       = pick;
window.checkForm                  = checkForm;
window._toggleNameField           = _toggleNameField;
window.onEmailBlur                = onEmailBlur;
window.submitEmail                = submitEmail;
window.copyCode                   = copyCode;
window.copyStickyCode             = copyStickyCode;
window.handleInterest             = handleInterest;
window.restartQuiz                = restartQuiz;
window.addRestartButton           = addRestartButton;
window.selectVariant              = selectVariant;
window.closeVariantSheet          = closeVariantSheet;
window.confirmVariant             = confirmVariant;
window.openVariantSheet           = openVariantSheet;
window.openDetailSheet            = openDetailSheet;
window.closeDetailSheet           = closeDetailSheet;
window.openDetailFromVariantSheet = openDetailFromVariantSheet;
window.openDetailVariantSheet     = openDetailVariantSheet;
window.openDetailInlineVariants   = openDetailInlineVariants;
window.selectDetailVariant        = selectDetailVariant;
window.addDetailInlineToCart      = addDetailInlineToCart;
window.confirmResume              = confirmResume;
window.modifyResume               = modifyResume;
window.openTonalitaLightbox        = openTonalitaLightbox;
window.closeTonalitaLightbox       = closeTonalitaLightbox;

/* ── Gallery lightbox coverflow per detail-sheet ─────────────────────────── */
var _glbOpen  = false;
var _glbImgs  = [];
var _glbIdx   = 0;
var _glbEl    = null;
var _glbProdName = '';

function _glbRender(animate) {
  var lb  = _glbEl;
  if (!lb) return;
  var cur = _glbIdx;
  var n   = _glbImgs.length;

  // Aggiorna dots
  var dotsEl = lb.querySelector('.ak-lb-dots');
  if (dotsEl) dotsEl.innerHTML = _glbImgs.map(function(_, i) {
    return '<span class="ak-lb-dot' + (i === cur ? ' active' : '') + '"></span>';
  }).join('');

  // Coverflow
  var items = lb.querySelectorAll('.ak-lb-slide');
  var dur   = animate ? '360ms' : '0ms';
  items.forEach(function(slide, i) {
    var rel = i - cur;
    var abs = Math.abs(rel);
    slide.style.transition = 'transform ' + dur + ' cubic-bezier(0.25,0.46,0.45,0.94), opacity ' + dur;
    slide.style.transform  = 'translateX(' + (rel * 62) + '%) rotateY(' + (-rel * 44) + 'deg) scale(' + (abs === 0 ? 1 : abs === 1 ? 0.72 : 0.52) + ')';
    slide.style.opacity    = abs === 0 ? 1 : abs === 1 ? 0.5 : 0.2;
    slide.style.zIndex     = 10 - abs;
    slide.style.pointerEvents = abs === 0 ? 'auto' : 'none';
  });
}

function _glbGoTo(idx) {
  var n = _glbImgs.length;
  _glbIdx = ((idx % n) + n) % n;
  _glbRender(true);
}
window._glbGoTo = _glbGoTo;

function openGalleryLightbox(prodId, startIdx) {
  if (_glbOpen) return;
  var prod = getCatalogProduct(prodId);
  if (!prod || !prod.imgs || prod.imgs.length === 0) return;
  _glbOpen     = true;
  _glbImgs     = prod.imgs;
  _glbIdx      = startIdx || 0;
  _glbProdName = prod.name;
  window._glbMiInteressa = function() {
    closeGalleryLightbox();
    closeDetailSheet();
    setTimeout(function() { openVariantSheet(getCatalogProduct(prod.id)); }, 160);
  };

  var slides = _glbImgs.map(function(src, i) {
    return '<div class="ak-lb-slide"><img class="ak-lb-img" src="' + src + '" alt="' + prod.name + ' foto ' + (i+1) + '" draggable="false"></div>';
  }).join('');

  var lb = document.createElement('div');
  lb.id = 'galleryLightbox';
  lb.className = 'ak-lb-overlay';
  lb.innerHTML =
    '<div class="ak-lb-inner" onclick="event.stopPropagation()">'
    + '<button class="ak-lb-close" onclick="closeGalleryLightbox()">'
    + '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>'
    + '</button>'
    + '<div class="ak-lb-stage ak-lb-stage--square"><div class="ak-lb-track">' + slides + '</div></div>'
    + '<div class="ak-lb-caption" style="padding:12px 16px 16px">'
    + '<div class="ak-lb-dots"></div>'
    + '<strong class="ak-lb-title" style="font-size:14px">' + prod.name + '</strong>'
    + (prod.slug ? '<span class="ak-lb-sub" style="font-size:12px;margin-top:2px">' + prod.slug + '</span>' : '')
    + ((prod.why || prod.tagline) ? '<div class="prod-why-you" style="margin:10px 0 0;cursor:default"><span class="prod-why-you-label">' + _t('whyForYouLabel') + '' + (S.userName ? ', ' + S.userName : '') + '</span><span class="prod-why-you-text">' + (prod.why || prod.tagline) + '</span></div>' : '')
    + '<button class="ak-lb-atc" style="margin-top:10px" onclick="_glbMiInteressa()">' + _t('btnInterested') + '</button>'

  _glbEl = lb;

  var touchStartX = 0;
  lb.addEventListener('touchstart', function(e) { touchStartX = e.touches[0].clientX; }, { passive: true });
  lb.addEventListener('touchend', function(e) {
    var dx = e.changedTouches[0].clientX - touchStartX;
    if (Math.abs(dx) > 36) _glbGoTo(_glbIdx + (dx < 0 ? 1 : -1));
  }, { passive: true });
  lb.addEventListener('click', function(e) { if (e.target === lb) closeGalleryLightbox(); });

  document.body.appendChild(lb);
  document.body.style.overflow = 'hidden';
  requestAnimationFrame(function() {
    lb.classList.add('ak-lb-visible');
    // Intro: parte da idx-2 se ci sono abbastanza foto
    var n = _glbImgs.length;
    var target = _glbIdx;
    if (n > 2) {
      var startFrom = ((target - 2) % n + n) % n;
      _glbIdx = startFrom; _glbRender(false);
      var steps = []; var cur = startFrom;
      while (cur !== target) { cur = (cur + 1) % n; steps.push(cur); }
      var elapsed = 160;
      steps.forEach(function(si, i) {
        elapsed += [280, 180][i] !== undefined ? [280, 180][i] : 130;
        setTimeout(function() { _glbIdx = si; _glbRender(true); }, elapsed);
      });
    } else {
      _glbRender(false);
    }
  });
}
window.openGalleryLightbox = openGalleryLightbox;

function closeGalleryLightbox() {
  var lb = document.getElementById('galleryLightbox');
  if (!lb) return;
  lb.classList.remove('ak-lb-visible');
  _glbOpen = false; _glbEl = null;
  document.body.style.overflow = '';
  setTimeout(function() { if (lb.parentNode) lb.parentNode.removeChild(lb); }, 280);
}
window.closeGalleryLightbox = closeGalleryLightbox;
window._bindAccordionExclusive     = _bindAccordionExclusive;
window.addAllToCart               = addAllToCart;

// Funzioni richiamate da nc-experience.js o da altri script esterni
window.addToCart                  = addToCart;
window.refreshCartCount           = refreshCartCount;
window.getDiscountCode            = getDiscountCode;
window.getDiscountGroup           = getDiscountGroup;

/* ── Init ────────────────────────────────────────────────────────────── */
renderQuestionScreens();
updateUI();
refreshCartCount();
_installAbandonTracking();
initResumeFlow();


/* Bind del click su #headerCart per aprire il side-cart del tema.
   Attendiamo che il DOM sia pronto, poi anche un piccolo delay per dare
   tempo al cart-drawer-component di registrarsi. */
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(_bindHeaderCart, 100);
  });
} else {
  setTimeout(_bindHeaderCart, 100);
}

})();